/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import "./freight.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";
import {
  useParams,
  useNavigate,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import driverService from "../../service/driver.service";
import freightService from "../../service/freight.service";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Popover,
  TextField,
  Chip,
} from "@mui/material";
import "@trendmicro/react-datepicker/dist/react-datepicker.css";
import firebase, { storage } from "../../config/firebase";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import ShipperDialog from "../../components/popup-shipper/insert-shipper";
import LoopIcon from "@mui/icons-material/Loop";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextArea from "antd/es/input/TextArea";
import BackButton from "../../components/backButton/BackButton";
import paymentService from "../../service/payment.service";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import notification from "../../service/sendMessage";
// import mdfeService from "../../service/mdfe.service";
import { Spin } from "antd";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InventoryIcon from "@mui/icons-material/Inventory";
import AlertDialogFreight from "./components/AlertDialogFreight";
import UploadInvoices from "./components/UploadInvoices";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FireTruckOutlinedIcon from "@mui/icons-material/FireTruckOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import GalleryDialog from "./components/GalleryDialog";
import FreightDriverNegotiationCard from "./components/FreightDriverNegotiationCard";
import ModernStepper from "./components/ProgressSteps";
import CancelFreightDialog from "./components/CancelFreightDialog";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MenuIcon from "@mui/icons-material/Menu";
// import shipperService from "../../service/shipper.service";
import userService from "../../service/user.service";
import ModernAlertDialog from "./components/ModernAlertDialog";
import InvoiceList from "./components/invoiceList";
import ReceiptIcon from "@mui/icons-material/Receipt";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import theme from "../../theme";

import FreightEditedSuccessModal from "./components/FreightEditedSuccessModal";

import Utils from "../../util/utils";
import ProductTable from "../../components/Product-Table-Freight/ProductTable";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
  FREIGHT_STATUS_CANCELABLE_CODES,
  STATUS_DESCRIBE_BY_CODE,
  getFreightPendingStatusByDriverPermission,
  resolveFreightStatusForSave,
  applyDefaultStopStatuses,
  buildFreightAttachments,
  buildFreightCanhotos,
  calcularDistancia,
  formatName,
  geraNumeroColeta,
  getAttachmentsByStoppingPointId,
  getCanhotosByStoppingPointId,
  formatStopDocument,
  getStoppingPointDocuments,
  getStoppingPointStatusLabel,
  hasCargaOperation,
  hasDescargaOperation,
  isStopLockedForEdition,
  mergeAttachmentLists,
  mergeCanhotoLists,
  normalizeAttachmentsList,
  normalizeCanhotosList,
  normalizeStopDocuments,
  resolveStatusCode,
  resolveStatusDescribe,
  withoutMaskPhone,
} from "./action/action";

import freightApi2 from "../../service/modules/freight.api";

import {
  COLORS,
  SOFT_SHADOW,
  sxWrap,
  sxCard,
  sxFlag,
  sxActionDock,
  sxIconBtn,
  sxFlag2,
} from "./css/formFields";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

require("firebase/auth");

const MERCHANDISE_TYPE_OPTIONS = [
  { value: "01", label: "01 - Granel Sólido" },
  { value: "02", label: "02 - Granel líquido" },
  { value: "03", label: "03 - Frigorificada" },
  { value: "04", label: "04 - Conteinerizada" },
  { value: "05", label: "05 - Carga Geral" },
  { value: "06", label: "06 - Neogranel" },
  { value: "07", label: "07 - Perigosa (granel sólido)" },
  { value: "08", label: "08 - Perigosa (granel líquido)" },
  { value: "09", label: "09 - Perigosa (carga frigorificada)" },
  { value: "10", label: "10 - Perigosa (conteinerizada)" },
  { value: "11", label: "11 - Perigosa (carga geral)" },
];

function parseStopNumericValue(value) {
  if (value === null || value === undefined || value === "") return NaN;
  if (typeof value === "number" && !Number.isNaN(value)) return value;
  const s = String(value).replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
}

function sumCargoStopsNumber(formFields, field) {
  if (!Array.isArray(formFields)) return 0;
  return formFields.reduce((acc, form) => {
    if (!hasCargaOperation(form.operation)) return acc;
    const n = parseStopNumericValue(form[field]);
    if (!Number.isFinite(n)) return acc;
    return acc + n;
  }, 0);
}

function hasPerStopCargoFreightFields(formFields) {
  return (
    Array.isArray(formFields) &&
    formFields.some((f) => hasCargaOperation(f.operation))
  );
}

/** Totais e valores somente leitura (IntlCurrencyInput desabilitado). */
function ReadonlyField({
  id,
  label,
  value,
  config,
  currency = "BRL",
  className = "col-md-2 mb-4",
}) {
  const safe =
    value === "" || value === undefined || value === null ? 0 : value;
  return (
    <div className={className}>
      <label htmlFor={id} className="font-test">
        {label}
      </label>
      <IntlCurrencyInput
        id={id}
        disabled
        currency={currency}
        config={config}
        value={safe}
        className="form-control"
        style={{
          borderRadius: "10px",
          backgroundColor: "#f3f4f6",
          color: "#111827",
          opacity: 1,
        }}
      />
    </div>
  );
}

function FreightCopy() {
  let navigate = useNavigate();

  const location = useLocation();

  const { id, idFreight } = useParams();

  const user = useSelector((state) => state.user);
  const canViewFreightCoordinates =
    user?.permissoes?.freightStoppingPointLatLong?.isView === true;
  const canViewFreightPricing = user?.permissoes?.freightPricing?.isView === true;
  const canViewFreightDriver = user?.permissoes?.freightDriver?.isView === true;
  const canViewFreightViewEditDriver =
    user?.permissoes?.freightViewEditDriver?.isView === true;
  /** Card motorista: ativo se qualquer uma das duas permissões estiver ligada (são independentes). */
  const canViewFreightDriverNegotiationUI =
    canViewFreightViewEditDriver || canViewFreightDriver;
  const canViewFreightSection = user?.permissoes?.freightFreight?.isView === true;
  /** Editar/selecionar motorista: permissão dedicada, ou perfil antigo sem a chave freightViewEditDriver (fallback freightDriver). */
  const canViewFreightDriverNegotiation =
    canViewFreightViewEditDriver ||
    (user?.permissoes?.freightViewEditDriver == null && canViewFreightDriver);

  const [loading, setLoading] = useState(false);

  // const [status, setStatus] = useState("Pendrente de contatação");
  const [status, setStatus] = useState("Pendente de contratação");
  const [code, setCode] = useState("01");

  useEffect(() => {
    if (id) return;
    const pending = getFreightPendingStatusByDriverPermission(
      canViewFreightViewEditDriver,
    );
    setStatus(pending.describe);
    setCode(pending.code);
  }, [id, canViewFreightViewEditDriver]);

  const [numberSerial, setNumberSerial] = useState(Date.now());
  const [verifyPayment, setVerifyPayment] = useState(false);

  const [budgetDataSaved, setBudgetDataSaved] = useState(null);

  // Client Payment
  const [payingCustomer, setPayingCustomer] = useState("");
  const [cnpjPayingCustomer, setCnpjPayingCustomer] = useState("");

  //Veiculo
  const [occupation, setOccupation] = useState();
  const [freeOfCharge, setFreeOfCharge] = useState();

  var nameUser = useSelector((state) => state?.user?.name);

  const [hasphoneRespContractFreigtage, setHasPhoneRespContractFreigtage] =
    useState(false);

  //Frete

  const [formFieldsOriginal, setFormFieldsOriginal] = useState("");
  const [freightOrigin, setFreightOrigin] = useState("");
  const [product, setProduct] = useState([]);
  const [operational, setOperational] = useState("");
  const [seller, setSeller] = useState(nameUser);
  const [valueNF, setValueNF] = useState("");
  const [valueFreightage, setValueFreightage] = useState("");
  const [totalAmountRoute, setTotalAmountRoute] = useState("");
  const [weightCargo, setWeightCargo] = useState(0);
  const [phoneRespContractFreigtage, setPhoneRespContractFreigtage] =
    useState("");
  const [valueDriverInitial, setValueDriverInitial] = useState(0);
  const [valueNegotiated, setValueNegotiated] = useState(0);
  const [paymentCondition, setPaymentCondition] = useState("");
  const [valueDriverFinal, setValueDriverFinal] = useState(0);
  const [uidDriver, setUidDriver] = useState("");
  const [observation, setObservation] = useState();
  const [internalObservations, setInternalObservations] = useState();
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [driversInFila, setDriversInFila] = useState([]);
  const [referenc, setReferenc] = useState("");
  const [driverChose, setDriverChose] = useState("");

  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();

  const [carregando, setCarregando] = useState(0);
  const usuarioEmail = useSelector((state) => state.usuarioEmail);

  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  const [origem, setOrigem] = useState("");
  const [openOrigem, setOpenOrigem] = useState(false);
  const [openUploadInvoices, setOpenUploadInvoices] = useState(false);
  const [openShipper, setOpenShipper] = useState(false);

  const [view, setOnlyView] = useState(location.state?.viewOnly || false);

  const [nameButtonImport, setNameButtonImport] = useState("Importar Canhoto");
  const [coordinates, setCoordinates] = useState(false);

  const [currentOperationType, setCurrentOperationType] = useState("");

  const [uidShipperPayment, setUidShipperPayment] = useState("");

  const [sellersList, setSellersList] = useState([]);

  const [load, setLoad] = useState(false);
  const [loadVerify, setLoadVerify] = useState(false);
  const skipBudgetProductsSyncRef = useRef(false);
  // Lista exibida no card (ordem visual atual dos grupos do embarcador).
  const [shipperGroups, setShipperGroups] = useState([]);
  // Estrutura persistida no backend para manter a ordem oficial do embarcador/frete.
  const [shipperGroupOrder, setShipperGroupOrder] = useState([]);

  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [openFreightEditedSuccessModal, setOpenFreightEditedSuccessModal] =
    useState({});
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openReactivateDialog, setOpenReactivateDialog] = useState(false);
  const [actionsMenuAnchorEl, setActionsMenuAnchorEl] = useState(null);

  var attachmentData = {
    id: "",
    name: "",
    stoppingPointId: "",
    type: "",
    url: "",
  };

  /* ====> Codigo feito por Lucas */
  // uidShipperPayment pode vir como string (fluxo antigo) ou objeto (fluxo novo).
  const selectedShipperId =
    typeof uidShipperPayment === "string"
      ? uidShipperPayment
      : uidShipperPayment?.uid || null;

  const getGroupName = (g) => g?.name || g?.nome || g?.descricao || "";

  // Monta o payload padronizado de groupOrder para salvar no shipper/frete.
  const buildGroupOrderToSave = (orderedGroups) => {
    const now = new Date().toISOString();

    return orderedGroups.map((g, index) => ({
      active: index === 0,
      idGroup: g.idGroup,
      date_includ: now,
      date_updated: now,
      name: getGroupName(g),
    }));
  };

  // Reordena grupos por drag-and-drop e persiste imediatamente no backend.
  const handleDragEndGroups = async (result) => {
    if (!result.destination) return;
    if (view) return;

    const items = Array.from(shipperGroups || []);
    if (items.length === 0) return;

    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setShipperGroups(items);

    const groupOrder = buildGroupOrderToSave(items);

    try {
      if (selectedShipperId) {
        await db
          .collection("shipper")
          .doc(selectedShipperId)
          .update({
            groupOrder,
            groupVisualizer: items.map((g) => ({ uid: g.idGroup })),
          });
      }

      if (idFreight) {
        await db.collection("freight").doc(idFreight).update({
          groupOrder,
        });
      }

      setShipperGroupOrder(groupOrder);
    } catch (e) {
      console.error("Erro ao salvar groupOrder:", e);
    }
  };

  // Sincroniza grupos do embarcador selecionado.
  // Prioridade:
  // 1) groupOrder (quando já existe ordenação salva)
  // 2) groupVisualizer (legado) + busca dos grupos na tb_group
  const syncGroupsFromShipper = async (shipperData) => {
    if (!shipperData) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    const groupOrder = Array.isArray(shipperData.groupOrder)
      ? shipperData.groupOrder.filter((group) => group?.idGroup)
      : [];

    if (groupOrder.length > 0) {
      setShipperGroups(groupOrder);
      setShipperGroupOrder(groupOrder);
      return;
    }

    const groupVisualizerIds = Array.isArray(shipperData.groupVisualizer)
      ? shipperData.groupVisualizer.map((group) => group?.uid).filter(Boolean)
      : [];

    if (groupVisualizerIds.length === 0) {
      setShipperGroups([]);
      setShipperGroupOrder([]);
      return;
    }

    try {
      const groupDocs = await Promise.all(
        groupVisualizerIds.map(async (groupId) => {
          const groupDoc = await db.collection("tb_group").doc(groupId).get();

          if (!groupDoc.exists) {
            return null;
          }

          return {
            idGroup: groupDoc.id,
            name: groupDoc.data()?.name || "",
            ...groupDoc.data(),
          };
        }),
      );

      const orderedGroups = groupDocs.filter(Boolean);

      setShipperGroups(orderedGroups);
      setShipperGroupOrder(buildGroupOrderToSave(orderedGroups));
    } catch (error) {
      console.error("Erro ao sincronizar grupos do embarcador:", error);
      setShipperGroups([]);
      setShipperGroupOrder([]);
    }
  };

  const getShipperDisplayName = (shipperData, fallback = "") => {
    const fantasyName = String(
      shipperData?.dataPersonal?.nameFantasy || "",
    ).trim();
    const socialName = String(shipperData?.dataPersonal?.socialName || "").trim();

    return fantasyName || socialName || fallback;
  };

  const getShipperOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return getShipperDisplayName(option, "");
  };

  const normalizeShipperName = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const filterShipperByDisplayName = (options, { inputValue }) => {
    const normalizedInput = normalizeShipperName(inputValue);

    if (!normalizedInput) return options;

    return options.filter((option) =>
      normalizeShipperName(getShipperDisplayName(option)).includes(
        normalizedInput,
      ),
    );
  };

  async function findShipperByUID(uid) {
    if (!uid) return null;
    try {
      const doc = await db.collection("shipper").doc(uid).get();
      if (doc.exists) {
        return { id: doc.id, ...doc.data() };
      }
      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por UID:", error);
      return null;
    }
  }

  async function findShipperByNomeFantasia(nomeFantasia) {
    if (!nomeFantasia) return null;
    const normalized = String(nomeFantasia).trim();
    if (!normalized) return null;

    try {
      const query = await db
        .collection("shipper")
        .where("dataPersonal.nameFantasy", "==", normalized)
        .get();

      if (!query.empty) {
        const doc = query.docs[0];
        return { id: doc.id, ...doc.data() };
      }

      return null;
    } catch (error) {
      console.error("Erro ao buscar shipper por nome fantasia:", error);
      return null;
    }
  }

  const applyPayingCustomerFromShipper = (
    shipperData,
    { fallbackName = "", fallbackCnpj = "", fallbackUid = "" } = {},
  ) => {
    if (!shipperData) return;

    setPayingCustomer(getShipperDisplayName(shipperData, fallbackName));
    setCnpjPayingCustomer(
      shipperData?.dataPersonal?.documentNumber || fallbackCnpj || "",
    );
    setUidShipperPayment(shipperData?.id || fallbackUid || "");
    setListECShipper(shipperData);
  };

  const resolveAndApplyPaymentShipper = async (
    { name = "", cnpj = "", uid = "" } = {},
    { shouldSyncGroups = false } = {},
  ) => {
    let shipperData = null;

    if (uid) {
      shipperData = await findShipperByUID(uid);
    }

    if (!shipperData && name) {
      shipperData = await findShipperByNomeFantasia(name);
    }

    if (!shipperData) return false;

    applyPayingCustomerFromShipper(shipperData, {
      fallbackName: name,
      fallbackCnpj: cnpj,
      fallbackUid: uid,
    });

    if (shouldSyncGroups) {
      syncGroupsFromShipper(shipperData);
    }

    return true;
  };

  function normalizeTransportOptionName(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  }
  function mergeSelectionOptions(defaultState, incomingState) {
    const defaultItems = Array.isArray(defaultState?.dados)
      ? defaultState.dados
      : [];
    const incomingItems = Array.isArray(incomingState?.dados)
      ? incomingState.dados
      : [];
    if (!incomingItems.length) return defaultState;
    const incomingByName = new Map(
      incomingItems.map((item) => [
        normalizeTransportOptionName(item?.name),
        Boolean(item?.selected),
      ]),
    );
    return {
      ...defaultState,
      dados: defaultItems.map((item) => {
        const key = normalizeTransportOptionName(item.name);
        return {
          ...item,
          selected: incomingByName.has(key)
            ? incomingByName.get(key)
            : Boolean(item.selected),
        };
      }),
    };
  }
  const handleModalResult = (value) => {
    if (!value) return;
    setOpenSuccessModal(false);
    navigate("/freightlistCopy");
  };
  /**
   * Função que atualiza o nome do botão de importação de acordo com o tipo de operação.
   * Se o tipo for "carga", o nome do botão é "Importar Canhoto", caso contrário, o nome é "Importar imagems".
   * @param {string} index - tipo de operação.
   */
  function handleNameButtonImport(index) {
    if (index === "carga") {
      setNameButtonImport("Importar Documentos");
    } else {
      setNameButtonImport("Importar imagens");
    }
  }

  /**
   * @author @Answercode2023
   * @param {*} event
   * @param {*} index
   * O código então verifica se o nome é "carga" ou "descarga"
   * e atualiza o array operation de acordo com o estado do checkbox.
   * Se a propriedade checked for verdadeira, ele define a propriedade operation como um array contendo o valor name.
   * Se for falsa, ele define operation como um array vazio.
   */
  const handleCheckBoxChange = (event, index) => {
    const { name, checked } = event.target;

    if (name === "carga" || name === "descarga") {
      setFormFields((prev) => {
        const data = [...prev];
        // Garante que sempre exista o array operation
        if (!Array.isArray(data[index].operation)) {
          data[index].operation = [];
        }

        if (checked) {
          data[index].operation = [name];
          if (name === "carga") {
            // Canhoto é exclusivo de descarga
            data[index].canhoto = "";
          }
        } else {
          data[index].operation = [];
        }
        return data;
      });
    }
  };

  const handleProductsChange = (newProducts) => {
    setProduct(newProducts);
    if (skipBudgetProductsSyncRef.current) {
      skipBudgetProductsSyncRef.current = false;
      setLoad(true);
      setLoadVerify(true);
      return;
    }
    const total =
      newProducts?.reduce((sum, prod) => sum + (prod.total || 0), 0) || 0;

    if (loadVerify) {
      setValueFreightage(total);
      return;
    }

    if (!load) {
      setValueFreightage(total);
      setLoad(true);
      return;
    }

    setValueFreightage(freightOrigin?.freight?.valueFreightage);
    setLoadVerify(true);
  };

  useEffect(() => {
    /**
     * Atualiza os campos operation e phoneRespContractFreight com base nos dados do motorista
     *
     * @returns {void}
     */
    const setOperationalAndPhoneFields = () => {
      if (driverChose !== "") {
        if (!hasphoneRespContractFreigtage) {
          setOperational(users.name);

          setPhoneRespContractFreigtage(users.phoneNumber);
        }

        // setPhoneRespContractFreigtage(users.phoneNumber);
      }
    };

    setOperationalAndPhoneFields();
  }, [driverChose]);

  /**
   * Carrega a lista de vendedores associados ao Fortio.
   * @throws {Error} - Se houver um erro ao carregar a lista de vendedores
   */
  async function loadingSellers() {
    try {
      const list = await userService.usersAssociatedWithFortio();

      setSellersList(list);
    } catch (error) {
      console.error("Erro ao carregar vendedores:", error);
    }
  }

  useEffect(() => {
    loadingSellers();
  }, []);

  {
    /* ====> Codigo acima feito por Lucas */
  }

  const db = firebase.firestore();

  const [typeBodyworkList, setTypeBodyworkList] = useState({
    dados: [
      { name: "BAÚ", selected: false },
      { name: "BAÚ FRIGORIFICO", selected: false },
      { name: "BAÚ REFRIGERADO", selected: false },
      { name: "SIDER", selected: false },
      { name: "CAÇAMBA", selected: false },
      { name: "GRADE BAIXA", selected: false },
      { name: "GRANELEIRO", selected: false },
      { name: "PLATAFORMA", selected: false },
      { name: "PRANCHA", selected: false },
      { name: "APENAS CAVALO", selected: false },
      { name: "BUG PORTA CONTAINER", selected: false },
      { name: "CAVAQUEIRA", selected: false },
      { name: "CEGONHEIRO", selected: false },
      { name: "GAIOLA", selected: false },
      { name: "HOPPER", selected: false },
      { name: "MUNCK", selected: false },
      { name: "SILLO", selected: false },
      { name: "TANQUE", selected: false },
    ],
  });

  {
    /**formFields representa um ponto de parada*/
  }
  const [formFields, setFormFields] = useState([
    {
      id: "",
      stop_order: 1,
      name: "",
      cpf_cnpj: "",
      operation: [],
      typeOperation: "",
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      cargo_weight_kg: "",
      cargo_value_nf: "",
      canhoto: "",
      documents: [],
      invoices: [],
      attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: false,
      typeDescarga: false,
      checkItemLocation: false,
      loadingStatus: "",
      unloadingStatus: "",
    },
  ]);

  const [isFormValid, setIsFormValid] = useState(false);

  /**
   * Valida os campos principais do formulário de pontos de parada.
   * Valida se todos os campos obrigatórios de cada ponto de parada
   * foram preenchidos.
   * @returns {boolean} True se o formulário estiver válido, false caso contrário.
   */
  const validateForm = () => {
    // --- Validação dos Campos Principais ---
    if (!cnpjPayingCustomer || !payingCustomer) return false;
    if (!occupation) return false;
    if (!freeOfCharge) return false;
    // if (!product) return false; // Se voltar a usar produto
    if (canViewFreightDriver && !valueDriverInitial) return false;
    if (canViewFreightDriver && !valueDriverFinal) return false;
    if (canViewFreightSection && !seller) return false;
    // if (!operational) return false;
    const perStopCargo = hasPerStopCargoFreightFields(formFields);
    if (canViewFreightSection && perStopCargo) {
      if (!valueFreightage) return false;
      for (const stop of formFields) {
        if (!hasCargaOperation(stop.operation)) continue;
        const w = parseStopNumericValue(stop.cargo_weight_kg);
        const nf = parseStopNumericValue(stop.cargo_value_nf);
        if (!Number.isFinite(w) || w <= 0) return false;
        if (!Number.isFinite(nf) || nf <= 0) return false;
      }
    } else if (canViewFreightSection) {
      if (!valueNF) return false;
      if (!weightCargo) return false;
      if (!valueFreightage) return false;
    }

    // Validação Condicional (se houver motorista)
    if (
      canViewFreightDriver &&
      uidDriver &&
      (!valueNegotiated || !paymentCondition)
    ) {
      return false;
    }

    if (!formFields || formFields.length === 0) {
      return false; // Precisa ter pelo menos um ponto de parada
    }

    for (const stop of formFields) {
      if (
        !stop.name ||
        !stop.cpf_cnpj ||
        stop.operation.length === 0 ||
        // !stop.responsible_name ||
        // !stop.responsible_phone ||
        !stop.date_operation ||
        !stop.time_operation ||
        !stop.cep ||
        !stop.number ||
        !stop.logradouro ||
        !stop.city ||
        !stop.uf
      ) {
        return false;
      }

      if (stop.operation.includes("carga")) {
        if (!stop.type || !stop.descricao) {
          console.log(
            "Validação falhou: Tipo ou Descrição obrigatórios para Carga no ponto:",
            stop,
          );
          return false;
        }
      }
    }

    return true;
  };

  useEffect(() => {
    const isValid = validateForm();
    setIsFormValid(isValid);
  }, [
    cnpjPayingCustomer,
    payingCustomer,
    valueDriverInitial,
    valueDriverFinal,
    occupation,
    freeOfCharge,
    // product, // Se voltar a usar
    seller,
    operational,
    valueNF,
    weightCargo,
    valueFreightage,
    uidDriver,
    valueNegotiated,
    paymentCondition,
    formFields,
    coordinates,
  ]);

  const addFields = () => {
    let object = {
      id: "",
      stop_order: formFields.length + 1,
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      number_collect: geraNumeroColeta(),
      date_operation: "",
      time_operation: "",
      type: "",
      descricao: "",
      cargo_weight_kg: "",
      cargo_value_nf: "",
      canhoto: "",
      documents: [],
      invoices: [],
      attachments: [],
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      latitude: "",
      longitude: "",
      manualCoordinatesEnabled: false,
      verify: false,
      observation: "",
      concluded: false,
      typeCarga: "",
      typeDescarga: "",
      checkItemLocation: false,
      loadingStatus: "",
      unloadingStatus: "",
    };
    setFormFields([...formFields, object]);
  };

  const [tipoVeiculo, setTipoVeiculo] = useState({
    dados: [
      { name: "FIORINO", selected: false },
      { name: "3/4", selected: false },
      { name: "TOCO", selected: false },
      { name: "VUC", selected: false },
      { name: "TRUCK", selected: false },
      { name: "BI-TRUCK", selected: false },
      { name: "BI-TREM", selected: false },
      { name: "CARRETA S", selected: false },
      { name: "CARRETA LS", selected: false },
      { name: "RODOTREM", selected: false },
      { name: "VANDERLEIA", selected: false },
    ],
  });

  // const [formFieldsOriginal, setFormFieldsOriginal] = useState("");
  // const [freightOrigin, setFreightOrigin] = useState("");

  const loadingPoints = (isCopy) => {
    var listResult = [];

    db.collection("freight")
      .doc(id)
      .collection("stopping_points")
      .get()
      .then(async (result) => {
        let freightAttachments = normalizeAttachmentsList(
          freightOrigin?.attachments,
        );
        let freightCanhotos = normalizeCanhotosList(freightOrigin?.canhoto);

        if (!freightAttachments.length || !freightCanhotos.length) {
          try {
            const freightSnapshot = await db
              .collection("freight")
              .doc(id)
              .get();
            const freightData = freightSnapshot.data() || {};

            if (!freightAttachments.length) {
              freightAttachments = normalizeAttachmentsList(
                freightData.attachments,
              );
            }

            if (!freightCanhotos.length) {
              freightCanhotos = normalizeCanhotosList(freightData.canhoto);
            }
          } catch (error) {
            console.error(
              "Erro ao carregar attachments/canhoto do documento principal:",
              error,
            );
          }
        }

        result.docs.forEach((doc) => {
          const operation = doc.data().operation || [];
          const canhotosFromMainDocument = getCanhotosByStoppingPointId(
            freightCanhotos,
            doc.id,
          );
          const legacyStopCanhotos = normalizeCanhotosList(
            doc.data().canhoto,
            doc.id,
          );
          const stopCanhotos = mergeCanhotoLists(
            canhotosFromMainDocument,
            legacyStopCanhotos,
            doc.id,
          );
          const attachmentsFromMainDocument = getAttachmentsByStoppingPointId(
            freightAttachments,
            doc.id,
          );
          const legacyStopAttachments = normalizeAttachmentsList(
            doc.data().attachments,
            doc.id,
          );
          const stopAttachments = mergeAttachmentLists(
            attachmentsFromMainDocument,
            legacyStopAttachments,
          );

          if (isCopy === true) {
            const copyLoadingStatus = operation.includes("carga")
              ? "LOADING_PENDING"
              : "";
            const copyUnloadingStatus = operation.includes("descarga")
              ? "UNLOADING_PENDING"
              : "";

            listResult.push({
              unloadingStatus: copyUnloadingStatus,
              loadingStatus: copyLoadingStatus,
              id: doc.id,
              stop_order: doc.data().stop_order,
              name: doc.data().name,
              cpf_cnpj: doc.data().cpf_cnpj,
              operation: operation,
              responsible_phone: doc.data().responsible_phone,
              responsible_name: doc.data().responsible_name,
              number_collect: doc.data().number_collect,
              date_operation: (doc.data().date_operation = ""),
              time_operation: (doc.data().time_operation = ""),
              canhoto: [],
              documents: [],
              invoices: [],
              attachments: [],
              cep: doc.data().cep,
              number: doc.data().number,
              logradouro: doc.data().logradouro,
              city: doc.data().city,
              uf: doc.data().uf,
              latitude: doc.data().latitude,
              longitude: doc.data().longitude,
              manualCoordinatesEnabled:
                doc.data().manualCoordinatesEnabled || false,
              verify: (doc.data().verify = false),
              observation: (doc.data().observation = ""),
              concluded: (doc.data().concluded = false),
              type: "",
              descricao: "",
              cargo_weight_kg: "",
              cargo_value_nf: "",
            });
            setFormFieldsOriginal(listResult);
          } else {
            const canShowStopCanhoto = hasDescargaOperation(operation);
            listResult.push({
              id: doc.id,
              stop_order: doc.data().stop_order,
              name: doc.data().name,
              cpf_cnpj: doc.data().cpf_cnpj,
              operation: operation,
              responsible_phone: doc.data().responsible_phone,
              responsible_name: doc.data().responsible_name,
              number_collect: doc.data().number_collect,
              date_operation: doc.data().date_operation,
              time_operation: doc.data().time_operation,
              canhoto: canShowStopCanhoto
                ? stopCanhotos.length > 0
                  ? stopCanhotos
                  : ""
                : "",
              documents: normalizeStopDocuments(doc.data().documents),
              invoices: normalizeStopDocuments(doc.data().invoices),
              attachments: stopAttachments,
              cep: doc.data().cep,
              number: doc.data().number,
              logradouro: doc.data().logradouro,
              city: doc.data().city,
              uf: doc.data().uf,
              latitude: doc.data().latitude,
              longitude: doc.data().longitude,
              verify: doc.data().verify,
              observation: doc.data().observation,

              concluded: doc.data().concluded,
              type: doc.data().type,
              descricao: doc.data().descricao,
              cargo_weight_kg: doc.data().cargo_weight_kg ?? "",
              cargo_value_nf: doc.data().cargo_value_nf ?? "",
              unloadingStatus: operation.includes("descarga")
                ? doc.data().unloadingStatus || "UNLOADING_PENDING"
                : doc.data().unloadingStatus || "",
              loadingStatus: operation.includes("carga")
                ? doc.data().loadingStatus || "LOADING_PENDING"
                : doc.data().loadingStatus || "",
            });
            setFormFieldsOriginal(listResult);
          }
        });

        handleNameButtonImport(listResult[0].operation[0]);
        setFormFieldsOriginal(listResult);
        setFormFields(listResult);
        setCarregando(0);
      })
      .catch((error) => {
        setCarregando(0);
        console.error(error);
      });

    return listResult;
  };

  var listClientIn = [];

  const [listClient, setListClient] = useState([]);
  const [listECClient, setListECClient] = useState([]);

  const handleChangeClient = (event) => {
    applyPayingCustomerFromShipper(event);
    syncGroupsFromShipper(event);
  };

  const [listShipper, setListShipper] = useState([]);
  const [listECShipper, setListECShipper] = useState("Embarcador");

  useEffect(() => {
    if (listShipper.length !== 1) return;

    const uniqueShipper = listShipper[0];
    if (!uniqueShipper || listECShipper?.id === uniqueShipper.id) return;

    applyPayingCustomerFromShipper(uniqueShipper);
    syncGroupsFromShipper(uniqueShipper);
  }, [listShipper, listECShipper]);

  async function loadingShipper() {
    try {
      if (users?.viewALL) {
        // Se tem permissão para ver todos, busca todos os shippers
        const result = await db.collection("shipper").get();
        const shippers = [];

        result.docs.forEach((doc) => {
          shippers.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        // TODO Esta tudo okay
        setListShipper(shippers);
        setCarregando(0);
      } else {
        // Verifica se há shippers afiliados
        if (
          users?.uidShipperAffiliates &&
          Array.isArray(users.uidShipperAffiliates)
        ) {
          const affiliateUids = Array.isArray(users?.uidShipperAffiliates)
            ? users.uidShipperAffiliates
            : [];
          const primaryUid = users?.uidShipper ? [users.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippers = [];

          // Busca cada shipper pelos IDs
          for (const uid of uids) {
            try {
              const docRef = db.collection("shipper").doc(uid);
              const docSnap = await docRef.get();

              if (docSnap.exists) {
                shippers.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }

          setListShipper(shippers);
          setCarregando(0);
        } else {
          // Busca apenas o shipper principal
          const result = await db
            .collection("shipper")
            .doc(users.uidShipper)
            .get();

          if (result.exists) {
            setListShipper(
              [
                {
                  id: result.id,
                  ...result.data(),
                },
              ],
            );
          }
          setCarregando(0);
        }
      }
    } catch (error) {
      setCarregando(0);
      console.error("Erro ao buscar shippers:", error);
    }
  }

  async function loadingCustomer() {
    await db
      .collection("client")
      .get()
      .then((result) => {
        result.docs.forEach((doc) => {
          listClientIn.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        setListClient(listClientIn);
        setListECClient([]);

        setCarregando(0);
      })
      .catch((error) => {
        setCarregando(0);
        console.error(error);
      });
  }

  function loadingQueue() {
    const affiliateUids = Array.isArray(user?.uidShipperAffiliates)
      ? user.uidShipperAffiliates
      : [];
    const shipperUids = Array.from(
      new Set([
        ...affiliateUids,
        ...(user?.uidShipper ? [user.uidShipper] : []),
      ]),
    );

    driverService
      .getDriversByShipperAccess({
        viewAll: Boolean(user?.viewALL),
        shipperUids,
      })
      .then((result) => {
      const listDriverInFila = [];

      result.docs.forEach(async (doc) => {
        const driverData = {
          id: doc.id,
          ...doc.data(),
        };

        const allDataRef = db
          .collection("drivers_users")
          .doc(doc.id)
          .collection("documents")
          .doc("allData");

        const allDataSnapshot = await allDataRef.get();

        if (allDataSnapshot.exists) {
          const extraData = allDataSnapshot.data();

          // Usa optional chaining para evitar erro quando personalData não existe
          const personal = extraData?.personalData || {};

          // Sobrescrevemos ou adicionamos os campos que o Autocomplete usa
          driverData.name = personal.fullName || driverData.name || "";
          driverData.cpf = personal.documentCpf || driverData.cpf || "";
        }

        // Verifica se a coleção myFreightList existe
        const myFreightListRef = db
          .collection("drivers_users")
          .doc(doc.id)
          .collection("myFreightsList");

        const myFreightListSnapshot = await myFreightListRef.get();

        // Adiciona uma propriedade para priorizar quem possui myFreightList
        driverData.hasMyFreightList = !myFreightListSnapshot.empty;

        listDriverInFila.push(driverData);

        // Após verificar todos os motoristas, organiza a lista
        if (listDriverInFila.length === result.docs.length) {
          const sortedList = listDriverInFila.sort((a, b) => {
            return b.hasMyFreightList - a.hasMyFreightList;
          });

          const withMyFreightList = sortedList.filter(
            (driver) => driver.hasMyFreightList,
          );
          const withoutMyFreightList = sortedList.filter(
            (driver) => !driver.hasMyFreightList,
          );

          const separatedList = [
            {
              __separator: true,
              name: "",
              cpf: "",
              value: "",
              id: "__sep_queue_top__",
              uid: "",
            },
            ...withMyFreightList,
            {
              __separator: true,
              name: "",
              cpf: "",
              value: "",
              id: "__sep_queue_mid__",
              uid: "",
            },
            ...withoutMyFreightList,
          ];

          setDriversInFila(separatedList);
          setCarregando(0);
        }
      });
      })
      .catch((error) => {
        setCarregando(0);
        console.error("Error loading driver queue:", error);
      });

  }

  async function searchIdPayment(id) {
    try {
      const dataDadoPayment = await paymentService.getEspecifico(id);

      const verifyData = dataDadoPayment.filter(
        (item) =>
          item.status?.toLowerCase() === "pago" ||
          item.status?.toLowerCase() === "solicitar pagamento",
      );

      if (verifyData.length > 0) {
        setVerifyPayment(true);
      }
    } catch (error) {
      console.error("Erro ao buscar pagamento:", error);
    }
  }

  function loadingInit(isCopy) {
    db.collection("freight")
      .doc(id)
      .get()
      .then(async (result) => {
        var freight = result.data();

        setFreightOrigin(freight);

        var clientPayment = freight.clientPayment;
        var vehicle = freight.vehicle;
        var driver = freight.driver;
        var freightTage = freight.freight;

        if (isCopy === true) {
          const copyPendingStatus = getFreightPendingStatusByDriverPermission(
            canViewFreightViewEditDriver,
          );
          // cabeçalho
          setNumberSerial(numberSerial);
          setStatus(copyPendingStatus.describe);
          setCode(copyPendingStatus.code);
          // Frete - motorista
          setUidDriver();
          setDriverChose("");
          // Dados da Entrega
          setObservation("");
          setInternalObservations("");
        } else {
          const statusDescribeFromDb = resolveStatusDescribe(freight?.status);
          const statusCodeFromDb = resolveStatusCode(
            freight?.status,
            statusDescribeFromDb,
          );

          setNumberSerial(freight.numberSerial);
          setStatus(
            statusDescribeFromDb ||
            STATUS_DESCRIBE_BY_CODE[statusCodeFromDb] ||
            "Pendente de contratação",
          );
          setCode(
            statusCodeFromDb ||
              getFreightPendingStatusByDriverPermission(
                canViewFreightViewEditDriver,
              ).code,
          );

          setUidDriver(freight.freight.getDriverFreight?.uidDriver);

          // Dados da Entrega
          setObservation(freightTage.observation);
          setInternalObservations(freightTage.internalObservations);

          if (isCopy === false) {
            await driverService
              .getDriverAvailable(freight.freight.getDriverFreight?.uidDriver)
              .then(async (itemDriver) => {
                setDriverChose(itemDriver.data());
              })
              .catch((erro) => {
                console.error(erro);
              });
          }
        }

        // pagador
        setPayingCustomer(clientPayment.name || "");
        setCnpjPayingCustomer(clientPayment.cnpj || "");
        setUidShipperPayment(clientPayment.uid || "");
        setListECShipper(clientPayment.name || "");
        await resolveAndApplyPaymentShipper(
          {
            name: clientPayment.name || "",
            cnpj: clientPayment.cnpj || "",
            uid: clientPayment.uid || "",
          },
          { shouldSyncGroups: false },
        );
        const freightGroupOrder = Array.isArray(freight?.groupOrder)
          ? freight.groupOrder.filter((group) => group?.idGroup)
          : [];
        const hasFreightGroupOrder = freightGroupOrder.length > 0;

        if (hasFreightGroupOrder) {
          setShipperGroups(freightGroupOrder);
          setShipperGroupOrder(freightGroupOrder);
        }

        if (!hasFreightGroupOrder && clientPayment.uid) {
          try {
            const shipperDoc = await db
              .collection("shipper")
              .doc(clientPayment.uid)
              .get();
            if (shipperDoc.exists) {
              syncGroupsFromShipper({
                id: shipperDoc.id,
                ...shipperDoc.data(),
              });
            } else {
              setShipperGroups([]);
              setShipperGroupOrder([]);
            }
          } catch (error) {
            console.error("Erro ao sincronizar grupos do embarcador:", error);
            setShipperGroups([]);
            setShipperGroupOrder([]);
          }
        } else if (!hasFreightGroupOrder) {
          setShipperGroups([]);
          setShipperGroupOrder([]);
        }

        // veiculo
        setTipoVeiculo((prev) =>
          mergeSelectionOptions(prev, vehicle.typeVehicle),
        );
        setTypeBodyworkList((prev) =>
          mergeSelectionOptions(prev, vehicle.typeBodywork),
        );
        setOccupation(vehicle.occupation);
        setFreeOfCharge(vehicle.freeOfCharge);

        // Motorista
        setValueDriverInitial(driver.valueInitial);
        setValueDriverFinal(driver.valueFinal);
        setValueNegotiated(driver.valueNegotiated);
        setPaymentCondition(driver.paymentCondition);

        // Frete
        setProduct(
          freightTage?.newProducts?.length > 0 ? freightTage.newProducts : [],
        );
        setSeller(freightTage.seller);
        setOperational(freightTage.operational);
        setHasPhoneRespContractFreigtage(
          freightTage.phoneRespContractFreigtage ? true : false,
        );
        setOperational(freightTage.userConfirmDriver);
        setPhoneRespContractFreigtage(freightTage.phoneRespContractFreigtage);
        setWeightCargo(freightTage.weightCargo);
        setValueNF(freightTage.valueNF);
        setValueFreightage(freightTage.valueFreightage);

        setLoad(true);

        // ???
        setTotalAmountRoute(freightTage.totalAmountRoute);

        setCarregando(0);
      })
      .catch((error) => {
        console.error(error);
        setMsgTipo("erro");
        setCarregando(0);
        setTitle(" Ops!");
        setMsg(
          "Não foi possível carregar o frete no momento, por favor tente mais tarde.",
        );
        setOpen(true);
        return;
      });
  }

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  var isCopy = params.get("copy") === null ? false : true;

  const [idVerify, setId] = useState(id);

  useEffect(() => {
    let isCopyTemp = isCopy === false ? false : true;

    if (isCopyTemp === false) {
      if (idVerify) {
        loadingInit(isCopyTemp);
        loadingPoints();
        searchIdPayment(idVerify);
      }
    } else {
      loadingInit(isCopyTemp);
      loadingPoints(isCopyTemp);
      setId(null);
    }

    /**
     * A chamada loadingQueue() foi comentada, por que estava sendo chamada,
     * antes de o Redux preencher o estado user e users.uidShipper, o que causava erro na consulta.
     *  A chamada foi movida para um useEffect que monitora a variável users.
     **/
    // loadingQueue();
    loadingCustomer();
    loadingShipper();
  }, [idVerify, isCopy]);

  useEffect(() => {
    if (!location.state?.fromBudget || !location.state?.budgetData) return;

    const budgetData = location.state.budgetData;
    const stops = location.state.stops || [];

    setBudgetDataSaved({
      budgetId: location.state.budgetId,
      budgetData,
      stops,
    });

    if (budgetData.clientPayment) {
      setPayingCustomer(budgetData.clientPayment.name || "");
      setCnpjPayingCustomer(budgetData.clientPayment.cnpj || "");
      setUidShipperPayment(budgetData.clientPayment.uid || "");
      setListECShipper(budgetData.clientPayment.name || "");

      resolveAndApplyPaymentShipper(
        {
          name: budgetData.clientPayment.name || "",
          cnpj: budgetData.clientPayment.cnpj || "",
          uid: budgetData.clientPayment.uid || "",
        },
        { shouldSyncGroups: true },
      )
        .then((appliedBudgetPaymentShipper) => {
          if (!appliedBudgetPaymentShipper) {
            setListECShipper(budgetData.clientPayment.name || "");
            setShipperGroups([]);
            setShipperGroupOrder([]);
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar shipper:", error);
          setListECShipper(budgetData.clientPayment.name || "");
          setShipperGroups([]);
          setShipperGroupOrder([]);
        });
    }

    if (budgetData.vehicle) {
      setTipoVeiculo((prev) =>
        mergeSelectionOptions(prev, budgetData.vehicle.typeVehicle),
      );
      setTypeBodyworkList((prev) =>
        mergeSelectionOptions(prev, budgetData.vehicle.typeBodywork),
      );
      setOccupation(budgetData.vehicle.occupation || "");
      setFreeOfCharge(budgetData.vehicle.freeOfCharge || "");
    }

    if (budgetData.pricing?.products) {
      skipBudgetProductsSyncRef.current = true;
      setProduct(budgetData.pricing.products || []);
    }

    if (budgetData.summary) {
      setSeller(budgetData.summary.seller || "");
      setWeightCargo(budgetData.summary.weightCargo || 0);
      setValueNF(budgetData.summary.valueNF || "");
      setValueFreightage(budgetData.summary.valueFreightage || "");
      setPaymentCondition(budgetData.summary.paymentCondition || "");
      setObservation(budgetData.summary.observation || "");
    }

    if (budgetData.numberSerial) {
      setNumberSerial(budgetData.numberSerial);
    }

    if (stops.length > 0) {
      setFormFields(stops);
      setFormFieldsOriginal(stops);
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  /**
   * Monitora a variável users e chama loadingQueue() quando users.uidShipper estiver disponível.
   */
  useEffect(() => {
    if (users && users.uidShipper) {
      loadingQueue();
    }
  }, [users]);

  /**
   * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper).
   */
  useEffect(() => {
    if (idVerify) return;
    // Quando o frete nasce de um orcamento aprovado, preservamos o pagador vindo do orcamento.
    if (location.state?.fromBudget || budgetDataSaved) return;

    /**
     * Busca os dados do shipper baseado no ID armazenado no Redux (users.uidShipper)
     * e atualiza o estado com os dados encontrados.
     * Se o shipper for encontrado, seta o estado com o nome da empresa e o CNPJ.
     * Caso contr rio, n o realiza nenhuma a o.
     */
    const searchForShipper = async () => {
      try {
        const fretesEncontrados = await freightService.getShipperById(
          users.uidShipper,
        );
        applyPayingCustomerFromShipper(fretesEncontrados, {
          fallbackUid: users.uidShipper,
        });
        syncGroupsFromShipper(fretesEncontrados);
      } catch (error) {
        console.error("Erro ao buscar fretes:", error);
      }
    };

    searchForShipper();
  }, [users, location.state, budgetDataSaved]);

  async function handleDriverSaveUidShipper(uidDriver, uidShipperFreight) {
    try {
      const driverRef = await driverService.getDriverDocumentsUID(uidDriver);

      if (!driverRef || driverRef.empty) {
        console.error("Motorista não encontrado para o UID:", uidDriver);
        return;
      }

      const driverData = driverRef.docs[0].data();

      let currentList;

      if (Array.isArray(driverData.uidShipper)) {
        currentList = driverData.uidShipper; // já é array mantém
      } else if (typeof driverData.uidShipper === "string") {
        currentList = [driverData.uidShipper]; // string vira array
      } else {
        currentList = []; // undefined/null []
      }

      if (currentList.includes(uidShipperFreight)) {
        return;
      }

      // Atualiza no serviço
      await driverService.updateDriverUidShipper(
        uidDriver,
        uidShipperFreight,
        currentList,
      );

      console.log("UID do embarcador salvo com sucesso para o motorista.");
    } catch (error) {
      console.error("Erro ao salvar UID do embarcador:", error);
    }
  }

  async function save() {
    setMsgTipo("erro");
    setCarregando(1);

    if (!validInput()) return;

    const chosenStatus = resolveFreightStatusForSave({
      canEditDriverOnFreight: canViewFreightViewEditDriver,
      uidDriver,
    });

    let customerPayment = {
      name: payingCustomer,
      cnpj: cnpjPayingCustomer,
      uid: uidShipperPayment,
    };

    let vehicle = {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation: occupation,
      freeOfCharge: freeOfCharge,
    };

    let driverFreight = {
      uidDriver: uidDriver ? uidDriver : "",
    };

    if (uidDriver && uidShipperPayment) {
      handleDriverSaveUidShipper(uidDriver, uidShipperPayment);
    }

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    //Ultima rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf:
        primeiraRota.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    let freight = {
      product: "",
      newProducts: product?.length > 0 ? product : [],
      seller: seller,
      userConfirmDriver: operational ? operational : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage: valueFreightage,
      totalAmountRoute: calcularDistancia(
        primeiraRota.latitude,
        primeiraRota.longitude,
        ultimaRota?.latitude,
        ultimaRota?.longitude,
      ),
      observation: observation ? observation : "",
      internalObservations: internalObservations ? internalObservations : "",
      phoneRespContractFreigtage: withoutMaskPhone(phoneRespContractFreigtage),
      getDriverFreight: driverFreight,
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers.dataPersonal.socialName,
    };

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let history = {
      initialDate: new Date(),
      initialDateContrate:
        chosenStatus.describe === "Contratado" ? new Date() : "",
      validationPendingDate:
        chosenStatus.describe === "Pendente de validação" ? new Date() : "",
      partiallyDate:
        chosenStatus.describe === "Pendente de contratação" ? new Date() : "",
      atAnaliseDate: status === "Em Analise de perfil" ? new Date() : "",
      atAnaliseDateDriver:
        status === "Em Analise do motorista" ? new Date() : "",
    };

    var data = {
      attachments: formFields.attachments,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      driver: driver,
      freight: freight,
      user: user,
      shipper: shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history: history,
      // Persiste a ordem dos grupos no próprio frete para manter rastreabilidade da negociação.
      groupOrder: shipperGroupOrder,
    };

    const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
    const savedBudgetData =
      budgetDataSaved?.budgetData || location.state?.budgetData;

    if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
      data.fromBudget = true;
      data.budgetId = savedBudgetId;
      if (savedBudgetData?.numberSerial) {
        data.numberSerial = savedBudgetData.numberSerial;
      }
    }

    // return;

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
    } else {
      console.log("[Criando frete] Inserindo novo frete com dados : ");

      const payload = {
        ...data,
        canhoto: buildFreightCanhotos(formFields),
        attachments: buildFreightAttachments(formFields),
        stopping_points: applyDefaultStopStatuses(formFields),
      };

      try {
        const res = await freightApi2.create(payload);

        const freightId = res.data?.id;

        const dataMsg = {
          isSave: true,
          freightNumber: numberSerial,
          date: new Date(),
          msg: `O frete  foi salvo com sucesso.`,
          firstDelivery: {
            name: firstDelivery.name,
            uf: firstDelivery.uf,
          },
          lastDelivery: {
            name: lastDelivery.name,
            uf: lastDelivery.uf,
          },
        };

        setOpenFreightEditedSuccessModal(dataMsg);

        setOpenSuccessModal(true);

        // setCarregando(0);
        // navigate("/freightlist");
      } catch (err) {
        console.error(err);
        setCarregando(0);
        showMessage("Não foi possível criar o frete. Verifique a API.");
      }
    }
  }

  async function sendNotificationWithoutChoose(idFreight, idDriver) {
    console.log(
      "Enviando notificação para todos os motoristas que não foram escolhidos",
    );
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    const queueSnapshot = await db
      .collection("freight")
      .doc(idFreight)
      .collection("queue")
      .get();

    const queueData = queueSnapshot.docs.map((doc) => doc.data());
    const queueDataFiltered = queueData.filter(
      (item) => item.driver_user !== idDriver,
    );

    //Enviar notificação para todos os motoristas que não sejam o escolhido
    queueDataFiltered.forEach(async (item) => {
      const driverData = await driverService.getDriverAvailable(
        item.driver_user,
      );
      const driverUser = driverData.data();

      var title = "";
      var msg = "";

      title = "🚛 Quase lá!";
      msg =
        `Olá! ${driverUser.name}! 🎉\n\n` +
        `Você se candidatou ao frete #${numberSerial}, mas ele acabou sendo confirmado com outro motorista desta vez.\n` +
        `👀 Continue de olho no app — novos fretes estão chegando e a próxima pode ser sua!\n` +
        `Obrigado por estar com a gente.`;

      const freightData = {
        freightNumber: numberSerial,
        date: formattedDate,
        type: "new_freight",
      };

      notification.sendNotification(
        driverUser.idNotification,
        msg,
        title,
        freightData,
      );
    });
  }

  async function getDataPayment(value, driver, status, index) {
    var data = {
      idFreight: id,
      driver: uidDriver,
      order: numberSerial,
      value: (driver.valueNegotiated * parseInt(value)) / 100,
      type: index == 1 ? "Saldo" : "Adiantamento",
      status: status,
    };

    await paymentService.save(data);
  }

  // Função para verificar alterações
  async function update(isFinalize, isCopy) {
    setMsgTipo("erro");
    setCarregando(1);
    if (!validInput()) return;

    const defaultPendingStatus = getFreightPendingStatusByDriverPermission(
      canViewFreightViewEditDriver,
    );

    const resolvedDescribe =
      resolveStatusDescribe({ describe: status, code }, code) ||
      resolveStatusDescribe(freightOrigin?.status, code) ||
      defaultPendingStatus.describe;

    const resolvedCode =
      resolveStatusCode(
        { describe: resolvedDescribe, code },
        resolvedDescribe,
      ) || defaultPendingStatus.code;

    let chosenStatus = { describe: resolvedDescribe, code: resolvedCode };

    let customerPayment = {
      name: payingCustomer,
      cnpj: cnpjPayingCustomer,
      uid: uidShipperPayment,
    };

    let user = {
      uid: users.uid,
      name: users.name,
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers.dataPersonal.socialName,
    };

    // Cálculo da primeira e última rota
    const orderedStops = [...formFields]
      .filter((item) => item.stop_order != null)
      .sort((a, b) => a.stop_order - b.stop_order);

    const primeiraRota = orderedStops[0];
    const ultimaRota = orderedStops[orderedStops.length - 1];

    let firstDelivery = {
      name: primeiraRota?.name,
      cep: primeiraRota?.cep,
      address: primeiraRota?.logradouro,
      city: primeiraRota?.city,
      uf:
        primeiraRota?.uf.length > 2
          ? Utils.searchingState(primeiraRota.uf)
          : primeiraRota.uf,
      dateColeta: primeiraRota?.date_operation,
      coordinates: {
        latitude: primeiraRota?.latitude,
        longitude: primeiraRota?.longitude,
      },
    };

    let lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf:
        ultimaRota?.uf.length > 2
          ? Utils.searchingState(ultimaRota.uf)
          : ultimaRota.uf,
      dateColeta: ultimaRota?.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    const payloadWeightCargo = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_weight_kg")
      : weightCargo;
    const payloadValueNF = hasPerStopCargoFreightFields(formFields)
      ? sumCargoStopsNumber(formFields, "cargo_value_nf")
      : valueNF;

    // Dados organizados
    let freight = {
      product: "",
      newProducts: product?.length > 0 ? product : [],
      seller,
      userConfirmDriver: operational ? operational : "",
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage,
      totalAmountRoute: totalAmountRoute
        ? totalAmountRoute
        : calcularDistancia(
          primeiraRota.latitude,
          primeiraRota.longitude,
          ultimaRota?.latitude,
          ultimaRota?.longitude,
        ),
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },
    };

    let vehicle = {
      typeVehicle: tipoVeiculo,
      typeBodywork: typeBodyworkList,
      occupation,
      freeOfCharge,
    };

    let driver = {
      valueInitial: valueDriverInitial,
      valueFinal: valueDriverFinal,
      valueNegotiated: valueNegotiated,
      paymentCondition: paymentCondition,
    };

    if (uidDriver && uidShipperPayment) {
      handleDriverSaveUidShipper(uidDriver, uidShipperPayment);
    }

    let history = {
      dateFinished: isCopy ? "" : isFinalize ? new Date() : "",
      dateUpdate: new Date(),
    };

    let data = {
      attachments: formFields.attachments,
      numberSerial: numberSerial,
      clientPayment: customerPayment,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      freight,
      vehicle,
      driver,
      user,
      shipper,
      createUser: usuarioEmail,
      createData: new Date(),
      history,
      status: chosenStatus,
      // Mantém no update a mesma estrutura de groupOrder para não perder a ordem dos grupos.
      groupOrder: shipperGroupOrder,
    };

    const savedBudgetId = budgetDataSaved?.budgetId || location.state?.budgetId;
    const savedBudgetData =
      budgetDataSaved?.budgetData || location.state?.budgetData;

    if (budgetDataSaved || (location.state?.fromBudget && savedBudgetId)) {
      data.fromBudget = true;
      data.budgetId = savedBudgetId;
      if (savedBudgetData?.numberSerial) {
        data.numberSerial = savedBudgetData.numberSerial;
      }
    }

    if (!ultimaRota.date_operation) {
      showMessage("O data de coleta precisa ser preenchido");
      document.getElementById("datacoleta").focus();
      return;
    }

    if (status === "Contratado" || status === "Em transito" || uidDriver) {
      if (valueNegotiated === 0 || paymentCondition === "") {
        // Validação dos campos necessários para status 'Contratado'
        showMessage(
          "O Valor Negociado e a Condição de Pagamento são obrigatórios para fretes contratados.",
        );
        if (valueNegotiated === 0) {
          document.getElementById("valueNegotiated").focus();
        } else {
          document.getElementById("paymentCondition").focus();
        }
        return;
      }
    }

    // Verificar alterações nos campos críticos
    const originalFreight = {
      // product,
      seller,
      operational,
      valueNF: payloadValueNF,
      weightCargo: payloadWeightCargo,
      valueFreightage,
      totalAmountRoute: totalAmountRoute || "",
      observation: observation || "",
      internalObservations: internalObservations || "",
      phoneRespContractFreigtage,
      getDriverFreight: { uidDriver: uidDriver || "" },
    };

    // Comparar rotas originais e atuais
    const originalRoutes = JSON.stringify(formFieldsOriginal); // Salva a versão original das rotas antes da edição
    const currentRoutes = JSON.stringify(formFields);

    const fieldsChanged =
      hasFieldsChanged(originalFreight, freightOrigin.freight) ||
      JSON.stringify(vehicle) !== JSON.stringify(data.vehicle) ||
      JSON.stringify(driver) !== JSON.stringify(data.driver) ||
      originalRoutes !== currentRoutes;

    if (isFinalize) {
      if (code === "04" || code === "05" || code === "06") {
        //Status em transito ou entregue pode ser finalizado

        if (
          formFields.every(
            (field) =>
              normalizeCanhotosList(field.canhoto, field.id || "").length === 0,
          )
        ) {
          showMessage(
            "Atenção: É necessário preencher os conhotos de entrega antes de finalizar o frete",
          );
          return;
        }

        chosenStatus = {
          describe: "Finalizado",
          code: "07",
        };

        // Atualiza o campo 'concluded' para true
        formFields.forEach((field) => {
          field.verify = true;
          field.concluded = true;
        });

        // atualizar o status da fila dentro do motorista
        driverService.saveStatusMyFreight(uidDriver, id, "finished");
        // atualizar o status da fila dentro do frete
        freightService.saveStatusQueueFreight(id, uidDriver, "finished");
        // exluir o frete da fila do myFrete
        driverService.deleteStatusMyFreight(uidDriver, id);
      }

      if (status === "Finalizado" && !fieldsChanged) {
        chosenStatus = { describe: "Finalizado", code: "07" };
      }
    }

    if (status === "Finalizado" && fieldsChanged) {
      chosenStatus = { describe: "Em transito", code: "05" };
    }

    if (fieldsChanged && !uidDriver) {
      chosenStatus = getFreightPendingStatusByDriverPermission(
        canViewFreightViewEditDriver,
      );
    }

    // Frete cancelado pode voltar ao fluxo normal na edição.

    // Atualização no banco
    const payload = {
      ...data,
      canhoto: buildFreightCanhotos(formFields, freightOrigin?.canhoto),
      status: chosenStatus,
      attachments: buildFreightAttachments(
        formFields,
        Array.isArray(freightOrigin?.attachments)
          ? freightOrigin.attachments
          : [],
      ),
      stopping_points: applyDefaultStopStatuses(formFields),
    };

    try {
      console.log(
        "[Atualizando frete] Atualizando frete com dados : ",
        payload,
      );
      await freightApi2.update(id, payload, isFinalize);

      // mantém as regras de pagamentos/notificações do jeito que já está
      setCarregando(0);

      const dataMsg = {
        isSave: false,
        freightNumber: numberSerial,
        date: new Date(),
        msg: `O frete  foi atualizado com sucesso.`,
        firstDelivery: {
          name: firstDelivery.name,
          uf: firstDelivery.uf,
        },
        lastDelivery: {
          name: lastDelivery.name,
          uf: lastDelivery.uf,
        },
      };

      setOpenFreightEditedSuccessModal(dataMsg);

      setOpenSuccessModal(true);

      // navigate("/freightlistCopy");
    } catch (err) {
      console.error(err);
      setCarregando(0);
      showMessage("Não foi possível atualizar o frete. Verifique a API.");
    }
  }

  function hasFieldsChanged(original, updated) {
    return Object.keys(original).some(
      (key) => JSON.stringify(original[key]) !== JSON.stringify(updated[key]),
    );
  }

  // Função para lidar com a seleção ou remoção de um motorista
  const handleDriver = (event, isCopy) => {
    // Chama a função addDriverVerify com o ID do motorista (ou uma string vazia, se event for nulo/indefinido)
    addDriverVerify(event ? event.id : "");

    // Verifica se o parâmetro `isCopy` é "true" ou se o parâmetro `event` é nulo/indefinido
    if (isCopy === "true" || !event) {
      setUidDriver("");
      setDriverChose("");
    } else {
      setUidDriver(event.id ? event.id : "");
      setDriverChose(event ? event : "");
    }
  };

  //------------- Validações -----------------

  function validInput() {
    if (!cnpjPayingCustomer) {
      showMessage(
        "O campo CNPJ da cessão Cliente Pagador precisa ser preenchido",
      );
      document.getElementById("cnpjPayingCustomer").focus();
      return false;
    }
    if (!payingCustomer) {
      showMessage(
        "O campo Cliente da cessão Cliente Pagador precisa ser preenchido",
      );
      document.getElementById("payingCustomer").focus();

      return false;
    }
    if (canViewFreightDriver && !valueDriverInitial) {
      showMessage(
        "O campo Pagamento De: e descarga da cessão Motorista precisa ser preenchido",
      );
      document.getElementById("valueDriverInitial").focus();
      return false;
    }
    if (canViewFreightDriver && !valueDriverFinal) {
      showMessage(
        "O campo Pagamento Até: e descarga da cessão Motorista precisa ser preenchido",
      );
      document.getElementById("valueDriverFinal").focus();
      return false;
    }
    if (!occupation) {
      showMessage("O campo Ocupação da cessão Veículo precisa ser preenchido");
      document.getElementById("occupation").focus();
      return false;
    }
    if (!freeOfCharge) {
      showMessage(
        "O campo Livre de Carga e descarga da cessão Veículo precisa ser preenchido",
      );
      document.getElementById("freeOfCharge").focus();
      return false;
    }
    if (canViewFreightSection && !seller) {
      showMessage(
        "O campo Vendedor e descarga da cessão Frete precisa ser preenchido",
      );
      document.getElementById("seller").focus();
      return false;
    }
    if (canViewFreightSection && hasPerStopCargoFreightFields(formFields)) {
      const firstInvalid = formFields.findIndex((stop) => {
        if (!hasCargaOperation(stop.operation)) return false;
        const w = parseStopNumericValue(stop.cargo_weight_kg);
        const nf = parseStopNumericValue(stop.cargo_value_nf);
        return (
          !Number.isFinite(w) ||
          w <= 0 ||
          !Number.isFinite(nf) ||
          nf <= 0
        );
      });
      if (firstInvalid >= 0) {
        showMessage(
          "Preencha o Peso da Carga e o Valor NF em todas as paradas de carga.",
        );
        const el = document.getElementById(
          `weight-cargo-stop-${firstInvalid}`,
        );
        if (el) el.focus();
        return false;
      }
    } else if (canViewFreightSection && !valueNF) {
      showMessage(
        "O campo Valor NF e descarga da cessão Frete precisa ser preenchido",
      );
      document.getElementById("valueNF").focus();
      return false;
    } else if (canViewFreightSection && !weightCargo) {
      showMessage(
        "O campo Peso da Carga (Kg) e descarga da cessão Frete precisa ser preenchido",
      );
      document.getElementById("weightCargo").focus();
      return false;
    }
    if (canViewFreightSection && !valueFreightage) {
      showMessage(
        "O campo Valor do Frete e descarga da cessão Frete precisa ser preenchido",
      );
      document.getElementById("valueFreightage").focus();
      return false;
    }

    if (canViewFreightPricing) {
      for (const prod of product) {
        if (prod.nameProducts && (!prod.amount || !prod.priceList)) {
          showMessage(
            "Preencha todos os campos do produto: nome, quantidade e valor unitário.",
          );
          return false;
        }
        if (prod.amount && (!prod.nameProducts || !prod.priceList)) {
          showMessage(
            "Preencha todos os campos do produto: nome, quantidade e valor unitário.",
          );
          return false;
        }
        if (prod.priceList && (!prod.nameProducts || !prod.amount)) {
          showMessage(
            "Preencha todos os campos do produto: nome, quantidade e valor unitário.",
          );
          return false;
        }
      }
    }
    if (canViewFreightDriver && uidDriver && !valueNegotiated) {
      showMessage("O campo Valor Negociado precisa ser preenchido");
      document.getElementById("valueNegotiated").focus();
      return false;
    }
    if (canViewFreightDriver && uidDriver && !paymentCondition) {
      showMessage("O campo Condição de Pagamento precisa ser preenchido");
      document.getElementById("paymentCondition").focus();
      return false;
    }
    return true;
  }

  function showMessage(msg) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle("Campos obrigatórios!");
    setMsg(msg);
    setOpen(true);
    return;
  }

  const handleClickOpen = (id, operationType) => {
    setOpenOrigem(true);
    setReferenc(id);
    setCurrentOperationType(operationType || "");
  };

  const handleOpenUploadInvoices = (id, operationType) => {
    setReferenc(id);
    setCurrentOperationType(operationType || "");
    setOrigem("Invoices");
    setOpenUploadInvoices(true);
  };

  const isFreightCanceled = Boolean(
    resolveStatusCode(freightOrigin?.status, status) === "08" ||
    freightOrigin?.cancel_reason ||
    freightOrigin?.canceled ||
    freightOrigin?.cancelled ||
    freightOrigin?.canceled_at,
  );

  const canceledTimelineStatusCode = resolveStatusCode(
    freightOrigin?.status_before_cancel ||
      freightOrigin?.statusBeforeCancel ||
      freightOrigin?.canceled_step_status ||
      freightOrigin?.status_before_cancellation ||
      { code },
    status,
  );

  const timelineStatusCode =
    isFreightCanceled && canceledTimelineStatusCode !== "08"
      ? canceledTimelineStatusCode
      : isFreightCanceled
        ? "04"
        : code;

  const canShowCancelButton =
    Boolean(id) &&
    !view &&
    !isFreightCanceled &&
    FREIGHT_STATUS_CANCELABLE_CODES.includes(
      resolveStatusCode({ describe: status, code }, status),
    );

  const canShowActionsMenu =
    canShowCancelButton || (Boolean(id) && !view && isFreightCanceled);

  const handleOpenActionsMenu = (event) => {
    setActionsMenuAnchorEl(event.currentTarget);
  };

  const handleCloseActionsMenu = () => {
    setActionsMenuAnchorEl(null);
  };

  const handleOpenCancelDialogFromMenu = () => {
    handleCloseActionsMenu();
    setOpenCancelDialog(true);
  };

  const handleOpenReactivateDialogFromMenu = () => {
    handleCloseActionsMenu();
    setOpenReactivateDialog(true);
  };

  const handleReactivateFreight = async () => {
    try {
      setCarregando(1);

      const reactivatedStatus = {
        describe: "Pendente de contratação",
        code: "01",
      };

      const currentFreight =
        freightOrigin && typeof freightOrigin === "object" ? freightOrigin : {};

      const payload = {
        ...currentFreight,
        status: reactivatedStatus,
        freight: {
          ...(currentFreight.freight || {}),
          getDriverFreight: {
            ...(currentFreight.freight?.getDriverFreight || {}),
            uidDriver: "",
          },
        },
        driver: {
          ...(currentFreight.driver || {}),
          valueNegotiated: 0,
          paymentCondition: "",
        },
        cancel_reason: null,
        canceled: false,
        cancelled: false,
        canceled_at: null,
        status_before_cancel: null,
        status_before_cancellation: null,
        canceled_step_status: null,
      };

      await freightApi2.update(id, payload, false);

      setStatus("Pendente de contratação");
      setCode("01");
      setUidDriver("");
      setDriverChose("");
      setValueNegotiated(0);
      setPaymentCondition("");
      setFreightOrigin((prev) =>
        prev
          ? {
              ...prev,
              ...payload,
            }
          : prev,
      );
      setTitle("Frete reativado");
      setMsg("Frete reativado para Pendente de contratação.");
      setOpenReactivateDialog(false);
      setOpen(true);
    } catch (error) {
      console.error("Erro ao reativar frete:", {
        id,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        error?.message ||
        "Não foi possível reativar o frete. Verifique a API.";

      setMsgTipo("erro");
      setTitle("Atenção");
      setMsg(apiMessage);
      setOpenReactivateDialog(false);
      setOpen(true);
    } finally {
      setCarregando(0);
    }
  };

  const handleCancelFreight = async (reason) => {
    try {
      setCarregando(1);

      const canceledStatus = { describe: "Cancelado", code: "08" };
      const statusBeforeCancel = {
        describe:
          resolveStatusDescribe({ describe: status, code }, code) ||
          STATUS_DESCRIBE_BY_CODE[code] ||
          "Pendente de contratação",
        code: resolveStatusCode({ describe: status, code }, status),
      };
      const payload = {
        status: canceledStatus,
        cancel_reason: reason,
        canceled: true,
        canceled_at: new Date().toISOString(),
        status_before_cancel: statusBeforeCancel,
        canceled_step_status: statusBeforeCancel,
        history_status_freight: {
          reason,
          status: canceledStatus,
          status_before_cancel: statusBeforeCancel,
          date: new Date().toISOString(),
        },
      };

      await freightApi2.cancel(id, payload, reason);

      setStatus("Cancelado");
      setCode("08");
      setFreightOrigin((prev) =>
        prev
          ? {
              ...prev,
              status: canceledStatus,
              cancel_reason: reason,
              canceled: true,
              canceled_at: payload.canceled_at,
              status_before_cancel: statusBeforeCancel,
              canceled_step_status: statusBeforeCancel,
            }
          : prev,
      );
      setOpenCancelDialog(false);
      setTitle("Cancelamento realizado");
      setMsg("Frete cancelado com sucesso.");
      setOpen(true);
    } catch (error) {
      const endpoint = `/freight/v1/cancel/${id}`;

      console.error("Erro ao cancelar frete:", {
        id,
        endpoint,
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message,
      });

      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        error?.message ||
        "Verifique a API.";

      setMsgTipo("erro");
      setTitle("Atenção");
      setMsg(apiMessage);
      setOpen(true);
    } finally {
      setCarregando(0);
    }
  };

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const weightConfig = {
    locale: "en-US",
    formats: {
      number: {
        BRL: {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const currencyConfigKm = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          //   style: "Km",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  async function buscaAPISecondario(input, form, index, data) {
    setLoading(true);

    try {
      // Tenta primeiro a API local
      const fallbackData = await fetchLocalAPI(input);
      await processarDadosAPI(fallbackData, form, index, "local");
    } catch (error) {
      console.error("Erro na API local, tentando API externa:", error);
      try {
        // Fallback para API externa
        const fallbackData = await fetchExternalAPI(input);
        await processarDadosAPI(fallbackData, form, index, "external");
      } catch (externalError) {
        console.error("Erro na API Externa 1:", externalError);
        try {
          // Segunda Tentativa API Externa
          const fallbackData = await fetchExternalAPI2(input);
          await processarDadosAPI(fallbackData, form, index, "external2");
        } catch (externalError2) {
          console.error("Erro na API Externa 2:", externalError2);
          alert(externalError2);
          return null;
        }
      }
    } finally {
      setLoading(false);
    }
  }

  // Função para buscar na API local
  async function fetchLocalAPI(cnpj) {
    const response = await fetch(`http://localhost:4000/consulta/cnpj/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição local: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para buscar na API externa
  async function fetchExternalAPI(cnpj) {
    const response = await fetch(`https://open.cnpja.com/office/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  //Funcção para buscar na API Externa 2
  async function fetchExternalAPI2(cnpj) {
    const response = await fetch(
      `https://publica.cnpj.ws/cnpj/${Number(cnpj)}`,
    );
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Função para processar dados e obter coordenadas
  async function processarDadosAPI(fallbackData, form, index, apiType) {
    if (apiType === "local") {
      processarDadosLocal(fallbackData, form, index);
    } else if (apiType === "external") {
      processarDadosExterno(fallbackData, form, index);
    } else {
      processarDadosExterno2(fallbackData, form, index);
    }

    // Obter coordenadas
    await obterCoordenadas(form, index);

    // Salvar cliente
    await salvarCliente(form, index, fallbackData, apiType);

    setFormFields(form);
  }

  // Processar dados da API local
  function processarDadosLocal(data, form, index) {
    form[index]["name"] = data?.nome_fantasia;
    form[index]["cpf_cnpj"] = data?.cnpj;
    form[index]["cep"] = data?.endereco?.cep;
    form[index]["number"] = data?.endereco?.numero;
    form[index]["logradouro"] =
      `${data?.endereco?.logradouro} - ${data?.endereco?.bairro}`;
    form[index]["city"] = data?.endereco?.municipio?.descricao;
    form[index]["uf"] = data?.endereco?.uf;
    form[index]["responsible_phone"] =
      `${data?.telefones?.ddd}${data?.telefones?.numero}`;
  }

  // Processar dados da API externa
  function processarDadosExterno(data, form, index) {
    form[index]["name"] = data?.company?.name || "";
    form[index]["cpf_cnpj"] = data?.taxId || "";
    form[index]["cep"] = data?.address?.zip || "";
    form[index]["number"] = data?.address?.number || "";
    form[index]["logradouro"] = `${data?.address?.street || ""} - ${data?.address?.district || ""
      }`;
    form[index]["city"] = data?.address?.city || "";
    form[index]["uf"] = data?.address?.state || "";
    form[index]["responsible_phone"] = `${data?.phones?.area || ""}${data?.phones?.number || ""
      }`;
  }

  // Processar dados da API externa
  function processarDadosExterno2(data, form, index) {
    form[index]["name"] = data?.razao_social || "";
    form[index]["cpf_cnpj"] = data?.estabelecimento?.cnpj || "";
    form[index]["cep"] = data?.estabelecimento?.cep || "";
    form[index]["number"] = data?.estabelecimento?.numero || "";
    form[index]["logradouro"] =
      data?.estabelecimento?.logradouro + data?.estabelecimento?.complemento;
    form[index]["city"] = data?.estabelecimento?.cidade?.nome || "";
    form[index]["uf"] = data?.estabelecimento?.estado?.nome || "";
    form[index]["responsible_phone"] =
      `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
      }` ||
      `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
      }` ||
      `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
      }`;
  }

  // Função para obter coordenadas
  async function obterCoordenadas(form, index) {
    try {
      const cep = form[index]["cep"];
      const numero = form[index]["number"];

      if (!cep || !numero) {
        console.warn("CEP ou número não disponível para obter coordenadas");
        return;
      }

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${cep},${numero}&key=${key}`,
        { mode: "cors" },
      );

      const data = await response.json();

      if (data.status === "OK" && data.results.length > 0) {
        const address = data.results[0];
        form[index]["latitude"] = Number(address.geometry.location.lat);
        form[index]["longitude"] = Number(address.geometry.location.lng);
      } else {
        console.warn("CEP não encontrado no Google Maps");
      }
    } catch (error) {
      console.error("Erro ao obter coordenadas:", error);
    }
  }

  // Função para salvar cliente
  async function salvarCliente(form, index, fallbackData, apiType) {
    let clientData;

    switch (apiType) {
      case "local":
        clientData = criarDadosClienteLocal(fallbackData, form, index);
        break;
      case "external":
        clientData = criarDadosClienteExterno(fallbackData, form, index);
        break;
      case "external2":
        clientData = criarDadosClienteExterno2(fallbackData, form, index);
        break;
      default:
        throw new Error(`API type desconhecido: ${apiType}`);
    }

    try {
      await driverService.saveClient(clientData);
    } catch (err) {
      console.error("Erro ao salvar cliente:", err);
      throw err; // Propaga o erro para tratamento superior
    }
  }

  // Criar dados do cliente para API local
  function criarDadosClienteLocal(data, form, index) {
    return {
      name: data?.razao_social || data?.nome_fantasia,
      nameFantasy: data?.nome_fantasia,
      cnpj: data?.cnpj,
      address: {
        cep: data?.endereco?.cep,
        city: data?.endereco?.municipio?.descricao,
        complement: data?.endereco?.complemento,
        neighborhood: data?.endereco?.bairro,
        number: data?.endereco?.numero,
        state: data?.endereco?.uf,
        street: data?.endereco?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.telefones?.ddd}${data?.telefones?.numero}`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa
  function criarDadosClienteExterno(data, form, index) {
    return {
      name: data?.company?.name,
      nameFantasy: data?.company?.name,
      cnpj: data?.taxId,
      address: {
        cep: data?.address?.zip,
        city: data?.address?.city,
        complement: `${data?.address?.street} - ${data?.address?.district}`,
        neighborhood: data?.address?.district,
        number: data?.address?.number,
        state: data?.address?.state,
        street: data?.address?.street,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone: `${data?.phones?.area}${data?.phones?.number}`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  // Criar dados do cliente para API externa 2
  function criarDadosClienteExterno2(data, form, index) {
    return {
      name: data?.razao_social,
      nameFantasy: data?.estabelecimento?.nome_fantasia,
      cnpj: data?.estabelecimento?.cnpj,
      address: {
        cep: data?.estabelecimento?.cep,
        city: data?.estabelecimento?.cidade?.nome,
        complement:
          data?.estabelecimento?.logradouro +
          data?.estabelecimento?.complemento,
        neighborhood: data?.estabelecimento?.bairro,
        number: data?.estabelecimento?.numero,
        state: data?.estabelecimento?.estado?.nome,
        street: data?.estabelecimento?.logradouro,
      },
      coordinates: {
        latitude: form[index]["latitude"],
        longitude: form[index]["longitude"],
      },
      telefone:
        `${data?.estabelecimento?.ddd1 || ""}${data?.estabelecimento?.telefone1 || ""
        }` ||
        `${data?.estabelecimento?.ddd2 || ""}${data?.estabelecimento?.telefone2
        }` ||
        `${data?.estabelecimento?.ddd_fax || ""}${data?.estabelecimento?.fax || ""
        }`,
      typePerson: 2,
      uidShipper: user.uidShipper,
    };
  }

  //Função para consultar CNPJ
  function buscarCNPJBancoClient(input, index) {
    if (input.length < 14) {
      return;
    } else if (input.length === 14) {
      db.collection("client")
        .where("cnpj", "==", input)
        .get()
        .then((result) => {
          if (result.empty) {
            buscaAPISecondario(input, [...formFields], index); // Passamos uma cópia fresca
          } else {
            const data = result.docs[0].data();
            setFormFields((prev) => {
              const newForm = [...prev];
              newForm[index] = {
                ...newForm[index],
                name: data.name,
                cpf_cnpj: data.cnpj,
                cep: data.address.cep,
                number: data.address.number,
                logradouro: `${data.address.street} - ${data.address.neighborhood}`,
                city: data.address.city,
                uf: data.address.state,
                latitude: data.coordinates?.latitude || "",
                longitude: data.coordinates?.longitude || "",
              };
              return newForm;
            });
          }
        })
        .catch((err) => console.error(err));
    } else if (input.length === 18) {
      const inputLimpo = input.replace(/[^\d]/g, "");
      db.collection("client")
        .where("cnpj", "==", inputLimpo)
        .get()
        .then((result) => {
          var form = [...formFields];
          if (result.empty) {
            try {
              buscaAPISecondario(inputLimpo, form, index);
            } catch (err) {
              console.error(err);
            }
          } else {
            result.docs.forEach((doc) => {
              const data = doc.data();

              form[index]["name"] = data.name;
              form[index]["cpf_cnpj"] = data.cnpj;

              if (
                data.responsible &&
                data.responsible.phoneResp &&
                data.responsible.responsible
              ) {
                form[index]["responsible_phone"] = data.responsible.phoneResp;
                form[index]["responsible_name"] = data.responsible.responsible;
              } else {
                console.log(
                  "Dados de responsável ausentes ou vazios para o documento:",
                  doc.id,
                );
              }

              let address;

              if (
                data.addressDelivery &&
                Object.keys(data.addressDelivery).length > 0
              ) {
                address = data.addressDelivery;
              } else {
                address = data.address;
              }

              form[index]["cep"] = address.cep;
              form[index]["number"] = address.number;
              form[index]["logradouro"] =
                address.street + " - " + address.neighborhood;
              form[index]["city"] = address.city;
              form[index]["uf"] = address.state;

              if (
                data.coordinates &&
                data.coordinates.latitude &&
                data.coordinates.longitude
              ) {
                form[index]["latitude"] = data.coordinates.latitude;
                form[index]["longitude"] = data.coordinates.longitude;
              } else {
                fetch(
                  "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                  form[index]["cep"] +
                  "&key=" +
                  key,
                  { mode: "cors" },
                )
                  .then((res) => res.json())
                  .then((data2) => {
                    if (data2.hasOwnProperty("erro")) {
                      alert("Cep não existente");
                    } else {
                      var address = data2.results[0];

                      form[index]["latitude"] = Number(
                        data.location?.coordinates.latitude
                          ? data.location.coordinates.latitude
                          : address?.geometry.location.lat,
                      );
                      form[index]["longitude"] = Number(
                        data.location?.coordinates.longitude
                          ? data.location.coordinates.longitude
                          : address?.geometry.location.lng,
                      );
                      // alert("Dados preenchidos");
                    }
                  });
              }
            });
            setFormFields(form);
          }
        })
        .catch((err) => console.error(err));
    } else {
      alert("CNPJ invalido");
    }
  }

  /**
   * Função para consultar CEP
   * @param {string} input - CEP a ser consultado
   * @param {number} index - Índice do campo de formulário que deve ser atualizado
   * @returns {void} - Nenhum valor de retorno
   */
  function buscarCepPaying(input, index) {
    if (input.length < 8) return;

    fetch("https://brasilapi.com.br/api/cep/v1/" + input)
      .then((res) => res.json())
      .then((data) => {
        if (data.hasOwnProperty("erro") || data.name === "CepPromiseError") {
          alert("CEP não encontrado");
        } else {
          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const aux = [...prev];

            aux[index] = {
              ...aux[index],
              logradouro:
                (data.street || "") + " - " + (data.neighborhood || ""),
              city: data.city || "",
              uf: data.state || "",
            };
            return aux;
          });

          // Chama a geolocalização passando o índice correto
          consultStreetByStreet(index);
        }
      })
      .catch((err) => console.error(err));
  }

  /**
   * Função para consultar as coordenadas de um endereço
   * @param {number} index - Índice do campo de formulário que deve ser atualizado
   * @returns {void} - Nenhum valor de retorno
   * @description
   * Realiza uma chamada para a API do Google Maps para obter as coordenadas (latitude e longitude) de um endereço.
   * Se o endereço for válido, atualiza o formulário com as coordenadas e marca o campo como "checked".
   * Caso contrário, abre um alert com uma mensagem de erro.
   */
  const key = "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";
  function consultStreetByStreet(index) {
    // Pegamos os valores atuais para a busca
    const item = formFields[index];
    if (!item.number || !item.logradouro || !item.city || !item.uf) {
      setTitle("Por favor!");
      setMsg("Preencher o Endereço, Número, Cidade e Estado...");
      setOpen(true);
      return;
    }

    const enderecoCompleto = `${item.logradouro} ${item.number} ${item.city} ${item.uf}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${enderecoCompleto}&key=${key}`,
    )
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          // Uso do callback (prev) para não apagar o que o usuário acabou de digitar
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return newForm;
          });
        }
      })
      .catch((err) => console.error(err));
  }

  const handleClose = () => {
    setOpen(false);
    setCarregando(0);
  };

  const handleChangeInitial = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverInitial(value);
  };

  const handleChangeFinal = (event, value, maskedValue) => {
    event.preventDefault();
    setValueDriverFinal(value);
  };

  const handleChangeValueNegotiated = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNegotiated(value);
  };

  const handleChangePaymentCondition = (event, value, maskedValue) => {
    const selectedValue = event.target.value;
    setPaymentCondition(selectedValue);
  };

  const handleChangeWeightCargo = (event, value, maskedValue) => {
    event.preventDefault();
    setWeightCargo(value);
  };

  const handleChangeValueNF = (event, value, maskedValue) => {
    event.preventDefault();
    setValueNF(value);
  };

  const handleChangeValueFreightage = (event, value, maskedValue) => {
    event.preventDefault();
    setValueFreightage(value);
  };

  const handleClickDialog = () => {
    setOpenDialog(false);
  };

  const verifyUiDriver = (event) => {
    addDriverVerify(event.target.value);
    setUidDriver(event.target.value && event.target.value);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    return;
  };

  const addDriverVerify = (id) => {
    if (id !== "Selecione" && id !== "") {
      setCarregando(0);
      setTitle("Notificação para o motorista");
      setMsg(
        "Ao confirmar o salvamento deste frete, o motorista será notificado e o frete ficará disponível em seu aplicativo.",
      );
      setOpen(true);
    }
  };

  const msgHaveContract = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Atenção!");
      setMsg(
        "Esse status geralmente é mudado automaticamente quando o motorista aceita a carga," +
        "tem certeza que deseja mudar esse status manualmente ?",
      );
      setOpen(true);
    }
  };

  const varifyHavingDriver = () => {
    if (!uidDriver) {
      setCarregando(0);
      setTitle("Ops!");
      setMsg(
        "Para esse tipo de Status precisará selecionar um Motorista disponível da fila no campo Motorista(s)",
      );
      setOpen(true);
    }
  };

  const getStatus = (status) => {
    if (status === "Contratado") {
      return "hired";
    }
    if (status === "Entregue") {
      return "delivered";
    }
    if (status === "Em transito") {
      return "inTransit";
    } else if (
      (status === "Pendente de validação" ||
        status === "Pendente de contratação" ||
        status === "Em Analise do motorista") &&
      uidDriver
    ) {
      return "approved";
    }
  };

  //----------------------------- checked box ------------------------------------

  const handleOnChange = (e, type) => {
    const { name, checked } = e.target;
    const newTypeVehicle = [...tipoVeiculo[type]];
    const index = newTypeVehicle.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeVehicle[index] = { name, selected: checked };
    }
    setTipoVeiculo((h) => ({ ...h, [type]: newTypeVehicle }));
  };

  const renderCheckboxList = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChange(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categories = {
    Leve: ["FIORINO", "3/4", "TOCO", "VUC"],
    Médio: ["TRUCK", "BI-TRUCK", "BI-TREM"],
    Pesado: ["BITREM", "CARRETA S", "CARRETA LS", "RODOTREM", "VANDERLEIA"],
  };

  const renderCategories = () => {
    return Object.keys(categories).map((category) => {
      const filteredOptions = tipoVeiculo.dados.filter((vehicle) =>
        categories[category].includes(vehicle.name),
      );

      return (
        <Card key={category} sx={{ border: "none", boxShadow: "none" }}>
          <div className="category-column">
            <h6 className="category-title">{category}</h6>

            {renderCheckboxList(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  const handleOnChangeBodyWork = (e, type) => {
    const { name, checked } = e.target;
    const newTypeBodyWork = [...typeBodyworkList[type]];
    const index = newTypeBodyWork.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeBodyWork[index] = { name, selected: checked };
    }
    setTypeBodyworkList((h) => ({ ...h, [type]: newTypeBodyWork }));
  };

  const renderCheckboxListBodyWork = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChangeBodyWork(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categoriesBodyWork = {
    Fechada: ["BAÚ", "BAÚ FRIGORIFICO", "BAÚ REFRIGERADO", "SIDER"],
    Aberta: ["CAÇAMBA", "GRADE BAIXA", "GRANELEIRO", "PLATAFORMA", "PRANCHA"],
    Especial: [
      "BUG PORTA CONTAINER",
      "CAVAQUEIRA",
      "CEGONHEIRO",
      "GAIOLA",
      "HOPPER",
      "MUNCK",
      "SILLO",
      "TANQUE",
    ],
  };

  const renderCategoriesBodyWork = () => {
    return Object.keys(categoriesBodyWork).map((category) => {
      const filteredOptions = typeBodyworkList.dados.filter((vehicle) =>
        categoriesBodyWork[category].includes(vehicle.name),
      );
      return (
        <Card className="mb-3" sx={{ border: "none", boxShadow: "none" }}>
          <div key={category} class="category-column">
            <h8 style={{ fontWeight: "bold", fontSize: "14px" }}>{category}</h8>
            {renderCheckboxListBodyWork(filteredOptions, "dados")}
          </div>
        </Card>
      );
    });
  };

  const getStoragePathFromDownloadUrl = (downloadUrl = "") => {
    const marker = "/o/";
    const start = String(downloadUrl).indexOf(marker);
    if (start === -1) return "";

    const pathStart = start + marker.length;
    const pathEnd = String(downloadUrl).indexOf("?", pathStart);
    const encodedPath =
      pathEnd === -1
        ? String(downloadUrl).substring(pathStart)
        : String(downloadUrl).substring(pathStart, pathEnd);

    return decodeURIComponent(encodedPath);
  };

  const deleteStorageFileByUrl = async (downloadUrl) => {
    const filePath = getStoragePathFromDownloadUrl(downloadUrl);
    if (!filePath) return;

    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
  };

  // ===================== [ handleUpload ]======================
  const handleUpload = (file, isInvoice) => {
    if (!file) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const storageRef = ref(
        storage,
        `freight/${id}/attachments/${Date.now()}-${referenc || "principal"}-${file.name}`,
      );

      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          );
          setCarregando(progress);
        },
        (error) => {
          alert(error);
          setCarregando(0); // Resetar carregamento em caso de erro
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
              const fileName = file.name;
              const fileType = fileName.split(".").pop().toLowerCase();
              const fileNameWithoutExtension = fileName.includes(".")
                ? fileName.slice(0, fileName.lastIndexOf("."))
                : fileName;

              const attachmentData = {
                id: `${Date.now()}-${Math.floor(Math.random() * 1000000)}`,
                name: fileNameWithoutExtension,
                stoppingPointId: referenc,
                type: fileType,
                url: downloadURL,
              };

              setFormFields((currentFormFields) => {
                const updatedFormFields = currentFormFields.map((field) => {
                  if (field.id === referenc) {
                    const existingAttachments = Array.isArray(field.attachments)
                      ? field.attachments
                      : [];
                    const existingInvoices = Array.isArray(field.invoices)
                      ? field.invoices
                      : [];
                    const existingCanhotos = normalizeCanhotosList(
                      field.canhoto,
                      field.id || referenc || "",
                    );
                    const operationTypeForUpload =
                      currentOperationType || field.operation;
                    const isCargaOperationType = hasCargaOperation(
                      operationTypeForUpload,
                    );
                    const isDescargaOperationType = hasDescargaOperation(
                      operationTypeForUpload,
                    );

                    if (isInvoice) {
                      return {
                        ...field,
                        invoices: [...existingInvoices, attachmentData],
                      };
                    }

                    if (isCargaOperationType && !isDescargaOperationType) {
                      return {
                        ...field,
                        canhoto: "",
                        attachments: [...existingAttachments, attachmentData],
                      };
                    }

                    if (isDescargaOperationType && !isCargaOperationType) {
                      return {
                        ...field,
                        canhoto: mergeCanhotoLists(
                          existingCanhotos,
                          [attachmentData],
                          field.id || referenc || "",
                        ),
                        attachments: [],
                      };
                    }

                    // Encontrou o ponto de parada correto
                    return {
                      ...field,
                      canhoto: mergeCanhotoLists(
                        existingCanhotos,
                        [attachmentData],
                        field.id || referenc || "",
                      ),
                      attachments: [...existingAttachments, attachmentData],
                    };
                  }
                  return field; // Retorna os outros campos sem modificação
                });
                return updatedFormFields; // Retorna o array atualizado
              });

              console.log(
                `Upload de ${file.name} concluído para ponto ${referenc}. Dados:`,
                attachmentData,
              );

              setCarregando(0);
              resolve(attachmentData);
            })
            .catch((error) => {
              setCarregando(0);
              reject(error);
            });
        },
      );
    });
  };

  const handleDeleteStopDocument = async ({
    kind,
    stopId,
    stopIndex,
    file,
  }) => {
    if (view) return false;
    if (!file?.url) return false;

    try {
      await deleteStorageFileByUrl(file.url);
    } catch (error) {
      // Nao bloqueia a remocao da referencia no banco/estado se o arquivo fisico falhar.
      console.error("Erro ao excluir o arquivo no storage:", error);
    }

    const nextFormFields = formFields.map((field, index) => {
      const matchById = stopId && field.id === stopId;
      const matchByIndex = !stopId && index === stopIndex;
      if (!matchById && !matchByIndex) return field;

      if (kind === "canhoto") {
        const currentCanhotos = normalizeCanhotosList(
          field.canhoto,
          field.id || stopId || "",
        );
        const nextCanhotos = currentCanhotos.filter(
          (item) => item?.url !== file.url,
        );
        return {
          ...field,
          canhoto: nextCanhotos.length ? nextCanhotos : "",
          verify: false,
        };
      }

      if (kind === "attachment") {
        const currentAttachments = Array.isArray(field.attachments)
          ? field.attachments
          : [];
        const nextAttachments = currentAttachments.filter(
          (item) => item?.url !== file.url,
        );
        return {
          ...field,
          attachments: nextAttachments,
        };
      }

      return field;
    });

    const nextFreightCanhotos = normalizeCanhotosList(
      freightOrigin?.canhoto,
    ).filter((item) => {
      if (kind !== "canhoto") return true;
      if (!item?.url || item.url !== file.url) return true;
      if (!stopId) return false;
      return String(item.stoppingPointId || "") !== String(stopId);
    });

    const nextFreightAttachments = normalizeAttachmentsList(
      freightOrigin?.attachments,
    ).filter((item) => {
      if (kind !== "attachment") return true;
      if (!item?.url || item.url !== file.url) return true;
      if (!stopId) return false;
      return String(item.stoppingPointId || "") !== String(stopId);
    });

    setFormFields(nextFormFields);
    setFreightOrigin((prev) => ({
      ...(prev || {}),
      canhoto: nextFreightCanhotos,
      attachments: nextFreightAttachments,
    }));

    try {
      if (id && stopId) {
        const updatedStop = nextFormFields.find((field) => field.id === stopId);
        const stoppingPointPayload =
          kind === "canhoto"
            ? {
              canhoto: updatedStop?.canhoto || "",
              verify: false,
            }
            : {
              attachments: updatedStop?.attachments || [],
            };

        await db
          .collection("freight")
          .doc(id)
          .collection("stopping_points")
          .doc(stopId)
          .update(stoppingPointPayload);
      }

      if (id) {
        const freightPayload =
          kind === "canhoto"
            ? { canhoto: nextFreightCanhotos }
            : { attachments: nextFreightAttachments };

        await db.collection("freight").doc(id).update(freightPayload);
      }
    } catch (error) {
      console.error("Erro ao atualizar exclusão no banco:", error);
      alert("Erro ao atualizar dados no banco.");
      return false;
    }

    return true;
  };

  const handleCloseModal = () => {
    setOpenOrigem(false);
    setCurrentOperationType("");
    setOrigem("");
    setReferenc("");
  };

  const handleCloseUploadInvoices = () => {
    setOpenUploadInvoices(false);
    setCurrentOperationType("");
    setOrigem("");
    setReferenc("");
  };

  const handleShipperCloseModal = () => {
    setOpenShipper(false);
  };

  const getDadaClient = (cnpj, razaosocial) => {
    setPayingCustomer(razaosocial);
    setCnpjPayingCustomer(cnpj);
  };

  /**
   * Função para atualizar os campos do formulário
   * @param {React.ChangeEvent} event - Evento de mudança do campo
   * @param {number} index - Índice do campo no array de campos
   */

  const handleFormChange = (event, index) => {
    const { name, value, type, checked } = event.target;

    // Verifica se o nome do campo e o índice são válidos
    if (!name || index < 0) {
      return;
    }

    // Usa a forma funcional do setState para garantir que trabalhamos com o estado mais recente
    // Isso evita race conditions quando outras funções também atualizam formFields
    setFormFields((prevFormFields) => {
      // Verifica se o índice é válido
      if (index >= prevFormFields.length) {
        return prevFormFields;
      }

      // Cria uma cópia do array de pontos de parada
      const newFormFields = [...prevFormFields];

      // Cria uma cópia do objeto do ponto de parada no índice especificado
      const updatedField = { ...newFormFields[index] };

      // Atualiza o campo modificado
      // Para checkboxes, usa 'checked', caso contrário usa 'value'
      const fieldValue = type === "checkbox" ? checked : value || "";
      updatedField[name] = fieldValue;

      // Atualiza o objeto no array
      newFormFields[index] = updatedField;

      // Retorna o novo array
      return newFormFields;
    });
  };

  const deleteItem = (item, index) => {
    setFormFields((prev) => {
      const data = [...prev];
      data.splice(index, 1);
      return data;
    });
  };

  const duplicateForm = (index) => {
    setFormFields((prev) => {
      // Pega o formulário que será duplicado
      const formToDuplicate = prev[index];

      // Verifica se o formulário a ser duplicado existe
      if (!formToDuplicate) {
        console.error("Formulário não encontrado no índice:", index);
        return prev;
      }

      // Cria uma cópia profunda do formulário original
      let newForm = JSON.parse(JSON.stringify(formToDuplicate));

      // Modifica os campos específicos do novo formulário
      newForm.stop_order = formToDuplicate.stop_order + 1;
      newForm.date_operation = "";
      newForm.time_operation = "";
      newForm.observation = "";
      newForm.number_collect = geraNumeroColeta();
      newForm.manualCoordinatesEnabled = false;

      // Adiciona o novo formulário à lista de formulários
      return [...prev, newForm];
    });
  };

  /**
   * Função para verificar se os campos do formulário de pontos de parada
   * estão preenchidos corretamente.
   * Verifica se todos os campos obrigatórios de cada ponto de parada
   * foram preenchidos.
   * @returns {array} Vetor com os nomes dos campos inválidos
   */
  const getInvalidFields = () => {
    const erros = [];

    // 1. Validação de Campos Simples (Pagador, Valores, Veículo, Frete)
    const simpleFields = [
      // --- Pagador ---
      { value: payingCustomer, label: "Cliente Pagador", id: "chose-1" },
      {
        value: cnpjPayingCustomer,
        label: "CNPJ do Pagador",
        id: "cnpjPayingCustomer",
      },

      // --- Veículo ---
      { value: occupation, label: "Ocupação", id: "occupation" },
      {
        value: freeOfCharge,
        label: "Livre de Carga e Descarga",
        id: "freeOfCharge",
      },

    ];
    if (canViewFreightDriver) {
      simpleFields.push(
        {
          value: valueDriverInitial,
          label: "Valor Sugerido (Motorista)",
          id: "valueDriverInitial",
        },
        {
          value: valueDriverFinal,
          label: "Valor Anunciado (Motorista)",
          id: "valueDriverFinal",
        },
      );
    }
    if (canViewFreightSection) {
      simpleFields.push({ value: seller, label: "Vendedor", id: "seller" });
      if (hasPerStopCargoFreightFields(formFields)) {
        simpleFields.push(
          {
            value: sumCargoStopsNumber(formFields, "cargo_weight_kg"),
            label: "Peso da Carga (total por paradas)",
            id: "weightCargoTotal",
          },
          {
            value: sumCargoStopsNumber(formFields, "cargo_value_nf"),
            label: "Valor NF (total por paradas)",
            id: "valueNFTotal",
          },
        );
      } else {
        simpleFields.push(
          { value: weightCargo, label: "Peso da Carga", id: "weightCargo" },
          { value: valueNF, label: "Valor da NF", id: "valueNF" },
        );
      }
      simpleFields.push({
        value: valueFreightage,
        label: "Valor do Frete",
        id: "valueFreightage",
      });
    }

    // Verifica lista simples
    simpleFields.forEach((field) => {
      if (
        !field.value ||
        field.value === 0 ||
        (typeof field.value === "string" && field.value.trim() === "")
      ) {
        erros.push(field.label);
      }
    });

    // Se existe um uidDriver, estes campos tornam-se obrigatórios para status "Contratado"
    if (canViewFreightDriver && uidDriver && uidDriver !== "") {
      if (!valueNegotiated || valueNegotiated === 0) {
        erros.push("Valor Negociado (Obrigatório ao selecionar motorista)");
      }
      if (!paymentCondition) {
        erros.push(
          "Condição de Pagamento (Obrigatório ao selecionar motorista)",
        );
      }
    }

    // 3. Validação de Arrays Pontos de Parada
    if (!formFields || formFields.length === 0) {
      erros.push("Pontos de Parada (Adicione pelo menos um ponto)");
    } else {
      formFields.forEach((stop, index) => {
        const stopNum = stop.stop_order || index + 1;

        // Validações Gerais do Ponto
        if (!stop.name) erros.push(`Ponto ${stopNum}: Nome/Razão Social`);
        if (!stop.cpf_cnpj) erros.push(`Ponto ${stopNum}: CNPJ/CPF`);
        if (!stop.cep) erros.push(`Ponto ${stopNum}: CEP`);
        if (!stop.logradouro) erros.push(`Ponto ${stopNum}: Endereço`);
        if (!stop.number) erros.push(`Ponto ${stopNum}: Número`);
        if (!stop.city) erros.push(`Ponto ${stopNum}: Cidade`);
        if (!stop.uf) erros.push(`Ponto ${stopNum}: UF`);

        // Datas são cruciais para a logística
        if (!stop.date_operation)
          erros.push(`Ponto ${stopNum}: Data da Coleta/Entrega`);
        // if (!stop.time_operation)
        //   erros.push(`Ponto ${stopNum}: Hora da Coleta/Entrega`);

        // Validação da Operação (Carga/Descarga)
        if (!stop.operation || stop.operation.length === 0) {
          erros.push(`Ponto ${stopNum}: Selecione Carga ou Descarga`);
        }

        // Regra específica: Se for CARGA, precisa de Tipo e Descrição
        if (stop.operation && stop.operation.includes("carga")) {
          if (!stop.type)
            erros.push(
              `Ponto ${stopNum}: Tipo da Carga (Obrigatório para Carga)`,
            );
          if (!stop.descricao)
            erros.push(`Ponto ${stopNum}: Descrição (Obrigatório para Carga)`);
          if (
            canViewFreightSection &&
            hasPerStopCargoFreightFields(formFields)
          ) {
            const w = parseStopNumericValue(stop.cargo_weight_kg);
            const nf = parseStopNumericValue(stop.cargo_value_nf);
            if (!Number.isFinite(w) || w <= 0) {
              erros.push(`Ponto ${stopNum}: Peso da Carga (Kg)`);
            }
            if (!Number.isFinite(nf) || nf <= 0) {
              erros.push(`Ponto ${stopNum}: Valor NF`);
            }
          }
        }
      });
    }

    // Validação de Checkboxes de Veículos
    const hasSelectedVehicle = tipoVeiculo.dados.some((v) => v.selected);
    if (!hasSelectedVehicle) {
      // erros.push("Tipo de Veículo (Selecione pelo menos um)");
    }

    return erros;
  };

  /**
   * Função para tratar erros de campos obrigatórios
   * e exibir mensagem de erro para o usuário.
   * Se houver campos obrigatórios faltando, mostra
   * uma mensagem de erro com todos os campos faltando
   * de uma vez e para a execução. Caso contrário,
   * chama a função de salvar original.
   */
  const handleSave = () => {
    const camposInvalidos = getInvalidFields();

    if (camposInvalidos.length > 0) {
      // Exibe alerta com todos os campos faltando de uma vez
      setTitle("Campos( obrigatórios faltando");
      showMessage([
        "Alguns campos são de preenchimento obrigatório:",
        ...camposInvalidos,
      ]);
      // setStatus("error");
      setOpen(true);
      setLoading(false);
      return; // Para a execução e não salva
    }

    // Se passou, chama a função de salvar original

    idVerify === null || idVerify === undefined ? save() : update(false);
  };

  const cargoStops = formFields
    .map((form, index) => ({ form, index }))
    .filter(({ form }) => hasCargaOperation(form.operation))
    .sort(
      (a, b) =>
        (a.form.stop_order || a.index + 1) - (b.form.stop_order || b.index + 1),
    );

  const handleCargoProductChange = (index, field, value) => {
    setFormFields((prev) => {
      const newFormFields = [...prev];

      newFormFields[index] = {
        ...newFormFields[index],
        [field]: value,
      };

      return newFormFields;
    });
  };

  return (
    <div className="min-h-screen  " style={{ backgroundColor: "#F9FAFB" }}>
      <>
        {useSelector((state) => state.usuarioLogado) > 0 ? (
          <NewMiniDrawer
            divOpen={
              <Box
                sx={{
                  display: "block",
                  width: "100%",
                  mx: "1px",
                }}
              >
                <div
                  className="freight-content align-items-center"
                  style={{ paddingTop: "0px" }}
                >
                  {/* Dialog de upload de arquivo  */}
                  <AlertDialogFreight
                    handleClose={handleCloseModal}
                    open={openOrigem}
                    origem={origem}
                    handleUpload={handleUpload}
                    operationType={currentOperationType}
                    uploadProgress={carregando}
                  />

                  {/* Dialog de upload de arquivo  */}
                  <UploadInvoices
                    handleClose={handleCloseUploadInvoices}
                    open={openUploadInvoices}
                    origem={origem}
                    handleUpload={handleUpload}
                    operationType={currentOperationType}
                    uploadProgress={carregando}
                  />

                  <ShipperDialog
                    handleClose={handleShipperCloseModal}
                    open={openShipper}
                    dadosClient={getDadaClient}
                  />

                  <div className="container">
                    <div className="row">
                      <div className="col-5">
                        <p className="help-block">
                          {" "}
                          Número Orçamento:{" "}
                          <strong> {numberSerial} </strong>{" "}
                        </p>
                      </div>
                      <div className="col-5"></div>
                      <div className="col-2">
                        <div className="col-md-11 control-label">
                          <p className="help-block">
                            <span className="h11">*</span>
                            <strong> Campo Obrigatório </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row g-12">
                    <div
                      // class="btn-group"
                      role="group"
                      aria-label="Basic radio toggle button group"
                    >
                      {/* <HorizontalStepper status={code} /> */}

                      <div
                        style={{
                          alignItems: "flex-start",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "16px",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div style={{ flex: 1, minWidth: "280px" }}>
                          <ModernStepper
                            propsStatus={timelineStatusCode}
                            canceled={isFreightCanceled}
                          />
                        </div>

                        {canShowActionsMenu ? (
                          <>
                            <IconButton
                              aria-label="Abrir menu de acoes"
                              aria-controls={
                                actionsMenuAnchorEl ? "freight-actions-popover" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                actionsMenuAnchorEl ? "true" : undefined
                              }
                              onClick={handleOpenActionsMenu}
                              sx={{
                                alignSelf: "flex-start",
                                backgroundColor: theme.colors.highlight,
                                border: `1px solid ${theme.colors.highlight}`,
                                borderRadius: "14px",
                                boxShadow: theme.elevation.base,
                                color: theme.colors.surface,
                                height: "48px",
                                marginTop: "2px",
                                width: "48px",
                                "&:hover": {
                                  backgroundColor: theme.colors.surface,
                                  color: theme.colors.highlight,
                                  boxShadow: "0 4px 10px rgba(255, 49, 0, 0.22)",
                                },
                              }}
                            >
                              <MenuIcon />
                            </IconButton>
                            <Popover
                              id="freight-actions-popover"
                              open={Boolean(actionsMenuAnchorEl)}
                              anchorEl={actionsMenuAnchorEl}
                              onClose={handleCloseActionsMenu}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              PaperProps={{
                                sx: {
                                  borderRadius: "24px",
                                  boxShadow: "0px 10px 40px rgba(1, 36, 67, 0.15)",
                                  mt: 1,
                                  p: 1.5,
                                  width: 220,
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                }}
                              >
                                {isFreightCanceled ? (
                                  <Button
                                    fullWidth
                                    startIcon={<LoopIcon />}
                                    onClick={handleOpenReactivateDialogFromMenu}
                                    sx={{
                                      borderRadius: "14px",
                                      color: theme.colors.primary,
                                      fontWeight: theme.typography.weightSemibold,
                                      justifyContent: "flex-start",
                                      px: 1.5,
                                      py: 1,
                                      textTransform: "none",
                                      "& .MuiButton-startIcon": {
                                        color: theme.colors.highlight,
                                      },
                                      "&:hover": {
                                        backgroundColor: theme.colors.highlightSoft,
                                        color: theme.colors.highlight,
                                      },
                                    }}
                                  >
                                    Reativar
                                  </Button>
                                ) : null}
                                {canShowCancelButton ? (
                                  <Button
                                    fullWidth
                                    startIcon={<CancelOutlinedIcon />}
                                    onClick={handleOpenCancelDialogFromMenu}
                                    sx={{
                                      borderRadius: "14px",
                                      color: theme.colors.primary,
                                      fontWeight: theme.typography.weightSemibold,
                                      justifyContent: "flex-start",
                                      px: 1.5,
                                      py: 1,
                                      textTransform: "none",
                                      "& .MuiButton-startIcon": {
                                        color: theme.colors.highlight,
                                      },
                                      "&:hover": {
                                        backgroundColor: theme.colors.highlightSoft,
                                        color: theme.colors.highlight,
                                      },
                                    }}
                                  >
                                    Cancelar
                                  </Button>
                                ) : null}
                              </Box>
                            </Popover>
                          </>
                        ) : null}
                      </div>
                    </div>

                    <hr className="my-4" />
                  </div>

                  {listShipper.length > 1 && (
                    <Card
                      sx={{ padding: 2 }}
                      className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <div className="form-signin mx-auto mb-4 mb-lg-6">
                        {/* <h4 className="mb-3"> <AttachMoneyIcon fontSize="medium" /> Pagador</h4> */}

                        <h4
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <MonetizationOnIcon
                            fontSize="medium"
                            style={{ color: COLORS.danger }}
                          />{" "}
                          Pagador
                        </h4>

                        <div className="row justify-content-center align-items-center gx-3">
                          <div className="col-4">
                            <label
                              htmlFor="payingCustomerLabel"
                              className="font-test"
                            >
                              Cliente{" "}
                              <span style={{ color: COLORS.danger }}>*</span>
                            </label>

                            <Autocomplete
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              id="chose-1"
                              size="small"
                              disabled={view}
                              value={listECShipper && listECShipper}
                              getOptionLabel={getShipperOptionLabel}
                              filterOptions={filterShipperByDisplayName}
                              options={listShipper}
                              isOptionEqualToValue={(option, value) =>
                                option?.id === value?.id
                              }
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <li key={option?.id || key} {...optionProps}>
                                    {getShipperOptionLabel(option)}
                                  </li>
                                );
                              }}
                              onChange={(event, value) => {
                                handleChangeClient(value);
                              }}
                              noOptionsText="Nenhum Embarcador com esse nome foi encontrado"
                              renderInput={(params) => (
                                <TextField {...params} label="" />
                              )}
                            />
                          </div>

                          <div className="col-md-3">
                            <label
                              htmlFor="cnpjPayingCustomerLabel"
                              className="font-test"
                            >
                              CNPJ{" "}
                              <span style={{ color: COLORS.danger }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              name="cnpjPayingCustomer"
                              onChange={(e) =>
                                setCnpjPayingCustomer(e.target.value)
                              }
                              value={cnpjPayingCustomer && cnpjPayingCustomer}
                              className="form-control"
                              id="cnpjPayingCustomer"
                              style={{ borderRadius: "10px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  )}

                  {/** PONTOS DE PARADAS */}

                  <div className="row g-12">
                    <div
                      className="form-signin mx-auto mb-4 mb-lg-6 stop-points-shell"
                      style={{
                        background: COLORS.paper,
                        border: `1px solid ${COLORS.line}`,
                        boxShadow: SOFT_SHADOW,
                        borderRadius: "16px",
                        padding: "8px 12px 2px",
                      }}
                    >
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 1,
                          justifyContent: "space-between",
                          mb: 1.8,
                          mt: 0.2,
                          px: 0.6,
                        }}
                      >
                        <h4
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <LocationOnIcon
                            style={{ color: COLORS.danger }}
                            fontSize="medium"
                          />
                          Pontos de paradas
                        </h4>

                        <Chip
                          size="small"
                          label={`${formFields.length} parada${formFields.length === 1 ? "" : "s"
                            }`}
                          sx={{
                            fontSize: 16,
                            borderRadius: "8px",
                            background: "#ffffff",
                            border: `1px solid ${COLORS.line}`,
                            boxShadow: SOFT_SHADOW,
                            color: COLORS.ink,
                            fontWeight: 600,
                            "& .MuiChip-label": { px: 1.2 },
                          }}
                        />
                      </Box>

                      <div className="form-signin mx-auto mb-4 mb-lg-6">
                        {[...formFields]
                          .sort((a, b) => a.stop_order - b.stop_order)
                          .map((form, index) => {
                            const indiceReal = formFields.findIndex(
                              (item) =>
                                item.number_collect === form.number_collect,
                            );
                            const hasCargaStop = hasCargaOperation(
                              form.operation,
                            );
                            const hasDescargaStop = hasDescargaOperation(
                              form.operation,
                            );
                            const stoppingPointStatusLabel =
                              getStoppingPointStatusLabel(form);
                            const stoppingPointDocuments =
                              getStoppingPointDocuments(form);
                            const showCargaDocuments =
                              hasCargaOperation(form.operation) &&
                              stoppingPointDocuments.length > 0;
                            const stopLabel = `Parada ${form.stop_order || index + 1
                              }`;
                            const stopAttachments = Array.isArray(
                              form.attachments,
                            )
                              ? form.attachments.filter(
                                (attachment) => attachment && attachment.url,
                              )
                              : [];
                            const stopCanhotos = hasDescargaStop
                              ? normalizeCanhotosList(
                                form.canhoto,
                                form.id || "",
                              )
                              : [];
                            const hasCanhoto =
                              hasDescargaStop && stopCanhotos.length > 0;
                            const hasAttachments = stopAttachments.length > 0;
                            const hasProofFiles = hasCanhoto || hasAttachments;
                            const stopLockedForEdition =
                              isStopLockedForEdition(form);
                            const stopReadOnly = view || stopLockedForEdition;
                            const stopTypeLabel = hasCargaStop
                              ? "Carga"
                              : hasDescargaStop
                                ? "Descarga"
                                : "Sem tipo";
                            const proofLabel = hasProofFiles
                              ? "Com comprovante"
                              : "Sem comprovante";
                            const numberCollectLabel = form.number_collect ? form.number_collect : "N/A";
                            return (
                              <Box
                                key={`${form.id || form.number_collect || index}`}
                                component="span"
                                sx={sxWrap}
                                className="form-signin"
                              >
                                <Card
                                  className="form-signin mx-auto mb-4 mb-lg-6 p-3 align-items-center"
                                  sx={sxCard(hasProofFiles)}
                                >
                                  {stoppingPointStatusLabel && (
                                    <Box sx={[sxFlag, { borderRadius: "8px" }]}>
                                      <LocalShippingIcon
                                        sx={{
                                          color: COLORS.danger,
                                          fontSize: "0.95rem",
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: 16,

                                          // fontSize: "0.8rem",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {stoppingPointStatusLabel}
                                      </span>
                                    </Box>
                                  )}

                                  <Box sx={{ p: 2.5, pt: 7 }}>
                                    <Box
                                      sx={{
                                        alignItems: "center",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 1,
                                        mb: 2.2,
                                      }}
                                    >
                                      <Chip
                                        size="small"
                                        icon={
                                          <LocationOnIcon
                                            sx={{
                                              color: `${COLORS.ink} !important`,
                                              fontSize: "0.9rem",
                                            }}
                                          />
                                        }
                                        label={`Parada ${form.stop_order || index + 1}`}
                                        sx={{
                                          background: "#ffffff",
                                          border: `1px solid ${COLORS.line}`,
                                          color: COLORS.ink,
                                          fontSize: 16,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,

                                          "& .MuiChip-label": {
                                            fontSize: "0.94rem",
                                          },
                                        }}
                                      />
                                      <Chip
                                        size="small"
                                        label={stopTypeLabel}
                                        sx={{
                                          background: hasCargaStop
                                            ? "rgba(1,36,66,0.08)"
                                            : hasDescargaStop
                                              ? "rgba(255,49,0,0.12)"
                                              : "#ffffff",
                                          border: `1px solid ${hasDescargaStop
                                            ? "rgba(255,49,0,0.35)"
                                            : "rgba(1,36,66,0.2)"
                                            }`,
                                          color: hasDescargaStop
                                            ? COLORS.danger
                                            : COLORS.ink,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,
                                          "& .MuiChip-label": {
                                            fontSize: "0.94rem",
                                          },
                                        }}
                                      />
                                      <Chip
                                        size="small"
                                        label={proofLabel}
                                        sx={{
                                          background: hasProofFiles
                                            ? "rgba(255,49,0,0.08)"
                                            : "rgba(1,36,66,0.06)",
                                          border: `1px solid ${hasProofFiles
                                            ? "rgba(255,49,0,0.3)"
                                            : "rgba(1,36,66,0.2)"
                                            }`,
                                          color: hasProofFiles
                                            ? COLORS.danger
                                            : COLORS.inkSoft,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,
                                          "& .MuiChip-label": {
                                            fontSize: "0.94rem",
                                          },
                                        }}
                                      />
                                      <Chip
                                        size="small"
                                        label={`N.º ${numberCollectLabel}`}
                                        sx={{
                                          background: "#ffffff",
                                          border: `1px solid ${COLORS.line}`,
                                          color: COLORS.ink,
                                          fontSize: 16,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,
                                          "& .MuiChip-label": {
                                            fontSize: "0.94rem",
                                          },
                                        }}
                                      />
                                    </Box>
                                    <div className="row mb-5">
                                      <Spin spinning={loading} size="Large">
                                        <fieldset
                                          disabled={stopReadOnly}
                                          style={{
                                            border: 0,
                                            margin: 0,
                                            minWidth: 0,
                                            padding: 0,
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-1 mb-4">
                                              <label
                                                htmlFor="ordenacaoLabel"
                                                className="font-test"
                                              >
                                                Ordenação
                                              </label>
                                              <input
                                                disabled={view}
                                                type="number"
                                                name="stop_order"
                                                min={1}
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={
                                                  form.stop_order &&
                                                  form.stop_order
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                size={"small"}
                                                className="form-control"
                                                id="ordenacao"
                                                placeholder=""
                                              />
                                            </div>

                                            <div className="col-1 mb-2"></div>

                                            <div className="col-3 mb-2">
                                              <FormControl component="fieldset">
                                                <FormLabel id="demo-row-radio-buttons-group-label">
                                                  <label className="font-test">
                                                    Tipo de Parada{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                </FormLabel>
                                                <div className="row">
                                                  <div className="col-6 mb-2">
                                                    <FormControlLabel
                                                      disabled={view}
                                                      value="carga"
                                                      name="carga"
                                                      // disabled={form.concluded && isCopy !== "true"}
                                                      // disabled={form.operation.includes("descarga")}
                                                      onChange={(event) => {
                                                        handleFormChange(
                                                          event,
                                                          indiceReal,
                                                          "carga",
                                                        );
                                                        handleNameButtonImport(
                                                          "carga",
                                                        );
                                                        handleCheckBoxChange(
                                                          event,
                                                          indiceReal,
                                                        );
                                                      }}
                                                      // control={<Checkbox value={form.typeCarga && form.typeCarga}  />}
                                                      control={
                                                        <Checkbox
                                                          // disabled={disabledCheckBox}
                                                          value={
                                                            form.operation[0] &&
                                                            form.operation[0]
                                                          }
                                                          // checked={
                                                          //   form.operation[1] ===
                                                          //     "carga" ||
                                                          //     form.operation[0] ===
                                                          //     "carga"
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          checked={form.operation.includes(
                                                            "carga",
                                                          )}
                                                          disabled={form.operation.includes(
                                                            "descarga",
                                                          )}
                                                        />
                                                      }
                                                      label="Carga"
                                                    />
                                                  </div>
                                                  <div className="col-6 mb-2">
                                                    <FormControlLabel
                                                      disabled={view}
                                                      value="descarga"
                                                      name="descarga"
                                                      // disabled={form.concluded && isCopy !== "true"}
                                                      onChange={(event) => {
                                                        handleFormChange(
                                                          event,
                                                          indiceReal,
                                                          "descarga",
                                                        );

                                                        handleNameButtonImport(
                                                          "descarga",
                                                        );
                                                        handleCheckBoxChange(
                                                          event,
                                                          indiceReal,
                                                        );
                                                      }}
                                                      // control={<Checkbox value={form.typeDescarga && form.typeDescarga}  />}
                                                      control={
                                                        <Checkbox
                                                          value={
                                                            form.operation[1] &&
                                                            form.operation[1]
                                                          }
                                                          // checked={
                                                          //   form.operation[1] ===
                                                          //     "descarga" ||
                                                          //     form.operation[0] ===
                                                          //     "descarga"
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          checked={form.operation.includes(
                                                            "descarga",
                                                          )}
                                                          disabled={form.operation.includes(
                                                            "carga",
                                                          )}
                                                        />
                                                      }
                                                      label="Descarga"
                                                    />
                                                  </div>
                                                </div>
                                              </FormControl>
                                            </div>

                                            {/* <div className="col-6 mb-2">
                                          <FormGroup>
                                            <FormControlLabel style={{color: 'red'}} control={<Switch name="verify" 
                                                                                                checked={form.verify ? true : false} 
                                                                                                onChange={event => handleFormChange(event, index)} />} 
                                                                                                label="Motorista realizou a carga ou a descarga ?" />
                                          </FormGroup>
                                        </div> */}

                                            <div
                                              className="col-1 mb-2"
                                              direction="row"
                                            >
                                              <Box sx={sxActionDock}>
                                                <IconButton
                                                  size="small"
                                                  disabled={view}
                                                  onClick={() =>
                                                    duplicateForm(indiceReal)
                                                  }
                                                  sx={sxIconBtn("default")}
                                                >
                                                  <ContentCopyIcon fontSize="small" />
                                                </IconButton>

                                                <IconButton
                                                  size="small"
                                                  disabled={view}
                                                  onClick={() =>
                                                    deleteItem(form, indiceReal)
                                                  }
                                                  sx={sxIconBtn("danger")}
                                                >
                                                  <DeleteForeverIcon fontSize="small" />
                                                </IconButton>
                                              </Box>
                                            </div>
                                          </div>

                                          <div className="row">
                                            <div className="col-4">
                                              <label
                                                htmlFor="cnpjLabel"
                                                className="font-test"
                                              >
                                                CNPJ{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                name="cpf_cnpj"
                                                onChange={(event) => {
                                                  handleFormChange(event, indiceReal);
                                                }}
                                                onBlur={(event) => {
                                                  const value = event.target.value;
                                                  const onlyNumbers = value.replace(/\D/g, "");

                                                  if (onlyNumbers.length === 11 || onlyNumbers.length === 14) {
                                                    buscarCNPJBancoClient(onlyNumbers, indiceReal);
                                                  }
                                                }}
                                                value={form.cpf_cnpj || ""}
                                                className="form-control"
                                                id="cnpj"
                                                placeholder=""
                                              />
                                            </div>

                                            <div className="col-8">
                                              <label
                                                htmlFor="nomeLabel"
                                                className="font-test"
                                              >
                                                Nome{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                name="name"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={form.name && form.name}
                                                className="form-control"
                                                id="name"
                                                placeholder=""
                                              />
                                            </div>
                                          </div>

                                          <div className="row">
                                            <div className="col-2">
                                              <label
                                                htmlFor="cepLabel"
                                                className="font-test"
                                              >
                                                CEP{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                name="cep"
                                                onChange={(event) => {
                                                  // atualiza pelo que o usuário digita usando o índice real
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  );

                                                  // Só dispara a busca se tiver 8 dígitos numéricos
                                                  const rawValue =
                                                    event.target.value.replace(
                                                      /\D/g,
                                                      "",
                                                    );
                                                  if (rawValue.length === 8) {
                                                    buscarCepPaying(
                                                      rawValue,
                                                      indiceReal,
                                                    );
                                                  }
                                                }}
                                                value={form.cep || ""}
                                                maxLength={9}
                                                className="form-control"
                                                id="cep"
                                              />
                                            </div>

                                            <div className="col-md-4">
                                              <label
                                                htmlFor="addressLabel"
                                                className="font-test"
                                              >
                                                Endereço{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                name="logradouro"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={
                                                  form.logradouro &&
                                                  form.logradouro
                                                }
                                                className="form-control"
                                                id="address"
                                              />
                                            </div>

                                            <div className="col-md-1">
                                              <label
                                                htmlFor="numberLabel"
                                                className="font-test"
                                              >
                                                N.º{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                name="number"
                                                onChange={(event) => {
                                                  handleFormChange(event, indiceReal);
                                                }}
                                                onBlur={() => {
                                                  consultStreetByStreet(indiceReal);
                                                }}
                                                value={form.number || ""}
                                                className="form-control"
                                                id="numberAddress"
                                              />
                                            </div>

                                            <div className="col-2">
                                              <label
                                                htmlFor="city"
                                                className="font-test"
                                              >
                                                Cidade{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                name="city"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={form.city && form.city}
                                                className="form-control"
                                                id="cityAddress"
                                                placeholder=""
                                              />
                                            </div>

                                            <div className="col-md-1">
                                              <label
                                                htmlFor="stateInitialLabel"
                                                className="font-test"
                                              >
                                                Estado{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                name="uf"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={form.uf && form.uf}
                                                className="form-control"
                                                id="stateInitial"
                                              />
                                            </div>

                                            {/* <div className="col-md-2">
                                              <label
                                                htmlFor="stateInitialLabel"
                                                className="font-test"
                                              >
                                                Atualizar
                                              </label>
                                              {form.checkItemLocation ? (
                                                <Stack direction="row">
                                                  <Button
                                                    disabled={view}
                                                    variant="contained"
                                                    size="small"
                                                    onClick={(e) => {
                                                      consultStreetByStreet(
                                                        indiceReal,
                                                      );
                                                    }}
                                                    color="success"
                                                    // disabled={form.concluded && isCopy !== "true"}
                                                    startIcon={
                                                      <CheckCircleOutlineIcon />
                                                    }
                                                  >
                                                    Atualizado!
                                                  </Button>
                                                </Stack>
                                              ) : (
                                                <Stack direction="row">
                                                  <Button
                                                    disabled={view}
                                                    sx={{
                                                      backgroundColor:
                                                        "#012443",
                                                    }}
                                                    variant="contained"
                                                    size="small"
                                                    onClick={(e) => {
                                                      consultStreetByStreet(
                                                        indiceReal,
                                                      );
                                                    }}
                                                    color="primary"
                                                    // disabled={form.concluded && isCopy !== "true"}
                                                    startIcon={<LoopIcon />}
                                                  >
                                                    Atualizar
                                                  </Button>
                                                </Stack>
                                              )}
                                            </div> */}
                                          </div>

                                          <div className="row">
                                            {/* <div className="col-md-3">
                                              <label
                                                htmlFor="responsibleLabel"
                                                className="font-test"
                                              >
                                                Responsável
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                name="responsible_name"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                value={
                                                  form.responsible_name &&
                                                  form.responsible_name
                                                }
                                                className="form-control"
                                                id="responsible"
                                              />
                                            </div>

                                            <div className="col-3">
                                              <label
                                                htmlFor="phoneRespLabel"
                                                className="font-test"
                                              >
                                                Telefone Responsável
                                              </label>
                                              <InputMask
                                                disabled={view}
                                                mask="(99) 99999-9999"
                                                id="phoneResp"
                                                className="form-control"
                                                name="responsible_phone"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                value={
                                                  form.responsible_phone &&
                                                  form.responsible_phone
                                                }
                                                placeholder="(99) 99999-9999"
                                              />
                                            </div> */}

                                            {/* <div className="col-md-2">
                                              <label
                                                htmlFor="numberColetaLabel"
                                                className="font-test"
                                              >
                                                Número da coleta{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                disabled={view}
                                                type="text"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                name="number_collect"
                                                value={
                                                  form.number_collect &&
                                                  form.number_collect
                                                }
                                                className="form-control"
                                                id="numbercoleta"
                                              />
                                            </div> */}

                                            <div className="col-md-2 mb-4">
                                              <label
                                                htmlFor="datacoletaLabel"
                                                className="font-test"
                                              >
                                                Data da Coleta
                                              </label>
                                              <input
                                                disabled={view}
                                                type="date"
                                                name="date_operation"
                                                // disabled={form.concluded && isCopy !== "true"}
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                value={
                                                  form.date_operation || ""
                                                }
                                                className="form-control"
                                                id="datacoleta"
                                              />
                                            </div>

                                            <div className="col-md-2 mb-4">
                                              <label
                                                htmlFor="horacoletaLabel"
                                                className="font-test"
                                              >
                                                Hora da Coleta
                                              </label>

                                              <InputMask
                                                disabled={view}
                                                mask="99:99"
                                                id="phoneResp"
                                                className="form-control"
                                                name="time_operation"
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                value={
                                                  form.time_operation &&
                                                  form.time_operation
                                                }
                                                placeholder="99:99"
                                              />
                                            </div>
                                          </div>

                                          {/* ===================================================================================== */}

                                          <div className="row">
                                            {canViewFreightCoordinates && (
                                              <>
                                                <div className="col-md-3 mb-2">
                                                  {" "}
                                                  <label
                                                    htmlFor="Latitude"
                                                    className="font-test"
                                                  >
                                                    Latitude
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name="latitude"
                                                    disabled={
                                                      !form.manualCoordinatesEnabled
                                                    }
                                                    value={
                                                      form.latitude && form.latitude
                                                    }
                                                    className="form-control"
                                                    id="latitude"
                                                    onChange={(event) =>
                                                      handleFormChange(
                                                        event,
                                                        indiceReal,
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div className="col-md-3 mb-4">
                                                  {" "}
                                                  <label
                                                    htmlFor="Longitude"
                                                    className="font-test"
                                                  >
                                                    Longitude
                                                  </label>
                                                  <input
                                                    type="text"
                                                    disabled={
                                                      !form.manualCoordinatesEnabled
                                                    }
                                                    name="longitude"
                                                    value={
                                                      form.longitude &&
                                                      form.longitude
                                                    }
                                                    className="form-control"
                                                    id="longitude"
                                                    onChange={(event) =>
                                                      handleFormChange(
                                                        event,
                                                        indiceReal,
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </>
                                            )}

                                          </div>
                                        </fieldset>
                                        {canViewFreightCoordinates && (
                                          <div className="row">
                                            <div className="col-md-3 mb-4">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{ height: "0px" }}
                                              >
                                                <label
                                                  htmlFor="Geoposição"
                                                  className="font-test "
                                                >
                                                  Informar Geolocalização
                                                </label>

                                                <Checkbox
                                                  id={`geoposicao-${index}`}
                                                  checked={
                                                    !!form.manualCoordinatesEnabled
                                                  }
                                                  onChange={(
                                                    event,
                                                    isChecked,
                                                  ) => {
                                                    const syntheticEvent = {
                                                      target: {
                                                        name: "manualCoordinatesEnabled",
                                                        type: "checkbox",
                                                        checked: isChecked,
                                                        value: isChecked,
                                                      },
                                                    };
                                                    // Chame a handleFormChange com o evento simulado e o índice
                                                    handleFormChange(
                                                      syntheticEvent,
                                                      indiceReal,
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>

                                            <div className="col-md-3 mb-4">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{ height: "0px" }}
                                              >
                                                {" "}
                                                <a
                                                  style={{ cursor: "pointer" }}
                                                  href={`https://www.google.com/maps/search/?api=1&query=${form.latitude},${form.longitude}`}
                                                  target="_blank"
                                                  rel="noreferrer noopener"
                                                >
                                                  <label
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    className="font-test mb-0"
                                                  >
                                                    Visualizar no Mapa
                                                  </label>
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                        <fieldset
                                          // disabled={stopReadOnly}
                                          style={{
                                            border: 0,
                                            margin: 0,
                                            minWidth: 0,
                                            padding: 0,
                                          }}
                                        >
                                          {/* ===================================================================== */}
                                          {showCargaDocuments && (
                                            <div className="col-md-12 mb-3">
                                              <label className="font-test">
                                                NF-s Importadas
                                              </label>
                                              <div
                                                style={{
                                                  border: `1px solid ${COLORS.line}`,
                                                  borderRadius: 10,
                                                  background: "#ffffff",
                                                  padding: "10px 12px",
                                                  boxShadow: SOFT_SHADOW,
                                                }}
                                              >
                                                <InvoiceList
                                                  items={stoppingPointDocuments}
                                                  title={`NF-s Importadas - ${stopLabel}`}
                                                  subtitle={null}
                                                  hintText={null}
                                                  showActions={false}
                                                  emptyText="Nenhum documento para exibir."
                                                  getItemKey={(
                                                    documentItem,
                                                    docIndex,
                                                  ) =>
                                                    `${form.id || form.number_collect || indiceReal}-document-${docIndex}`
                                                  }
                                                  renderItem={(
                                                    documentItem,
                                                    docIndex,
                                                  ) => {
                                                    const {
                                                      label: docTypeLabel,
                                                      value: docDisplayValue,
                                                      url: docUrl,
                                                    } = formatStopDocument(
                                                      documentItem,
                                                      docIndex,
                                                    );

                                                    return (
                                                      <div
                                                        style={{
                                                          alignItems: "center",
                                                          display: "flex",
                                                          flexWrap: "wrap",
                                                          gap: 8,
                                                          whiteSpace: "nowrap",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            background:
                                                              "rgba(1,36,66,0.1)",
                                                            borderRadius: 999,
                                                            border:
                                                              "1px solid rgba(1,36,66,0.2)",
                                                            color: "#012442",
                                                            fontSize: 12,
                                                            fontWeight: 400,
                                                            padding: "2px 8px",
                                                          }}
                                                        >
                                                          {docTypeLabel}
                                                        </span>
                                                        <span
                                                          style={{
                                                            fontFamily:
                                                              "monospace",
                                                            color: "#012442",
                                                            fontWeight: 400,
                                                          }}
                                                        >
                                                          {docUrl ? (
                                                            <a
                                                              href={docUrl}
                                                              target="_blank"
                                                              rel="noreferrer noopener"
                                                              style={{
                                                                color:
                                                                  "#012442",
                                                                textDecoration:
                                                                  "underline",
                                                              }}
                                                            >
                                                              {docDisplayValue}
                                                            </a>
                                                          ) : (
                                                            docDisplayValue ||
                                                            "-"
                                                          )}
                                                        </span>
                                                      </div>
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          )}
                                          <div className="row">
                                            <div className="col-md-12 mb-2">
                                              <label
                                                htmlFor="observation"
                                                className="font-test"
                                              >
                                                Observação
                                              </label>
                                              <TextArea
                                                disabled={view}
                                                name="observation"
                                                value={
                                                  form.observation &&
                                                  form.observation
                                                }
                                                // disabled={form.concluded && isCopy !== "true"}
                                                onChange={(event) =>
                                                  handleFormChange(
                                                    event,
                                                    indiceReal,
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="row justify-content-between align-items-center gx-3 ">
                                              <>
                                                {id ? (
                                                  <div className="d-flex align-items-center flex-wrap gap-2">
                                                    {/* <span
                                                        className="font-test gap-2"
                                                        style={{
                                                          color: COLORS.danger,
                                                          fontWeight: 400,
                                                        }}
                                                      >
                                                        Ainda não há comprovante
                                                        de entrega
                                                      </span> */}
                                                    <Button
                                                      // disabled={view}
                                                      variant="outlined"
                                                      sx={{
                                                        fontSize: 16,
                                                        borderColor:
                                                          "rgba(1,36,66,0.3)",
                                                        color: COLORS.ink,
                                                        fontWeight:
                                                          theme.typography
                                                            .weightSemibold,
                                                        // textTransform: "none",
                                                        boxShadow:
                                                          theme.elevation.base,
                                                        "&:hover": {
                                                          borderColor:
                                                            COLORS.danger,
                                                          color: COLORS.danger,
                                                          background:
                                                            "rgba(255,49,0,0.05)",
                                                        },
                                                      }}
                                                      onClick={(e) => {
                                                        setReferenc(null);
                                                        handleClickOpen(
                                                          form.id,
                                                          form.operation[0],
                                                        );
                                                        setOrigem("Canhoto");
                                                      }}
                                                    >
                                                      <UploadFileIcon
                                                        sx={{
                                                          mr: 1,
                                                          color:
                                                            theme.colors
                                                              .highlight,
                                                        }}
                                                      />
                                                      {nameButtonImport}
                                                    </Button>
                                                    {/* // ========================================= */}

                                                    {form.operation[0] ===
                                                      "carga" &&
                                                      form.invoices.length ==
                                                      0 && (
                                                        <Button
                                                          disabled={view}
                                                          variant="outlined"
                                                          sx={{
                                                            backgroundColor:
                                                              theme.colors
                                                                .primary,
                                                            color:
                                                              theme.colors
                                                                .surface,
                                                            fontWeight:
                                                              theme.typography
                                                                .weightSemibold,
                                                            "&:hover": {
                                                              borderColor:
                                                                COLORS.danger,
                                                              color:
                                                                COLORS.danger,
                                                              background:
                                                                "rgba(255,49,0,0.05)",
                                                            },
                                                            boxShadow:
                                                              theme.elevation
                                                                .base,
                                                            fontSize: 16,
                                                          }}
                                                          onClick={(e) => {
                                                            setReferenc(null);
                                                            handleOpenUploadInvoices(
                                                              form.id,
                                                              form.operation[0],
                                                            );
                                                          }}
                                                        >
                                                          <ReceiptIcon
                                                            sx={{
                                                              mr: 1,
                                                              color:
                                                                theme.colors
                                                                  .highlight,
                                                            }}
                                                          />
                                                          Importar NF-s
                                                        </Button>
                                                      )}
                                                  </div>
                                                ) : (
                                                  // <label>"" </label>
                                                  ""
                                                )}
                                              </>

                                              <>
                                                {hasCanhoto && (
                                                  <div className="mb-2">
                                                    <label className="font-test">
                                                      {stopCanhotos.length > 1
                                                        ? "Canhotos"
                                                        : "Canhoto"}
                                                    </label>
                                                    <GalleryDialog
                                                      data={stopCanhotos}
                                                      disabled={view}
                                                      onDelete={(item) =>
                                                        handleDeleteStopDocument(
                                                          {
                                                            kind: "canhoto",
                                                            stopId: form.id,
                                                            stopIndex:
                                                              indiceReal,
                                                            file: item,
                                                          },
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}

                                                {hasAttachments && (
                                                  <div>
                                                    <label className="font-test">
                                                      Anexos
                                                    </label>
                                                    <GalleryDialog
                                                      data={stopAttachments}
                                                      disabled={view}
                                                      onDelete={(item) =>
                                                        handleDeleteStopDocument(
                                                          {
                                                            kind: "attachment",
                                                            stopId: form.id,
                                                            stopIndex:
                                                              indiceReal,
                                                            file: item,
                                                          },
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              </>
                                            </div>

                                            {/* <div className="col-md-4">
                                                                        {
                                                                            form.canhoto && !form.verify ? 
                                                                                <Box sx={{ width: '100%', maxWidth: 500, padding: 4, color: 'red' }}>
                                                                                    <Typography variant="h7" gutterBottom>
                                                                                        Este ponto de parada está pronto para ser verificado, por favor confirme com a empresa responsável e marque como verificada. 
                                                                                    </Typography>
                                                                                </Box>
                                                                            : 
                                                                            ""
                                                                        }
                                                                    </div> */}
                                          </div>
                                        </fieldset>
                                      </Spin>
                                    </div>
                                  </Box>
                                </Card>
                              </Box>
                            );
                          })}
                        <div className="row">
                          <div className="col-8"></div>
                          <div className="col-4">
                            <Button
                              variant="contained"
                              disabled={view}
                              onClick={addFields}
                              style={{
                                backgroundColor: "#012442",
                                borderRadius: 12,
                                padding: "10px 14px",
                                fontWeight: 600,
                                textTransform: "none",
                                boxShadow: SOFT_SHADOW,
                              }}
                            >
                              <AddIcon style={{ color: COLORS.danger }} />
                              &nbsp;Adicionar ponto de parada
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Veículo */}
                    <Card
                      sx={{ padding: 2 }}
                      className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                        width: "100%",
                      }}
                    >
                      <h4
                        className="mb-3"
                        style={{
                          alignItems: "center",
                          color: COLORS.ink,
                          display: "flex",
                          fontWeight: 700,
                          gap: "8px",
                          margin: 0,
                        }}
                      >
                        <LocalShippingIcon className="localShippingIcon" />{" "}
                        Veículo
                      </h4>

                      <div className="container mt-4">
                        <div className="row justify-content-center">
                          <div className="col-lg-10 col-md-12">
                            <strong>
                              <label
                                htmlFor="occupation"
                                className="form-label h5 mb-3"
                              >
                                <Chip
                                  label="Tipo de Veículo"
                                  sx={{
                                    backgroundColor: "#012443",
                                    color: "white",
                                    fontWeight: "bold",
                                    border: "1px solid #FF3100",
                                    width: 150,
                                    height: 35,
                                    whiteSpace: "normal",
                                    justifyContent: "center",
                                    borderRadius: "10px",

                                    // Estilizando elementos internos (slots)
                                    "& .MuiChip-label": {
                                      fontSize: "0.9rem",
                                      paddingLeft: "4px",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                                <span style={{ color: COLORS.danger }}>*</span>
                              </label>
                            </strong>

                            <div className="left-section">
                              {renderCategories()}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="container mt-4">
                        <div className="row justify-content-center">
                          <div className="col-lg-10 col-md-12">
                            <strong>
                              <label
                                htmlFor="bodywork-label"
                                className="form-label h5 mb-3"
                              >
                                <Chip
                                  label="Tipo de Carroceria"
                                  sx={{
                                    backgroundColor: "#012443",
                                    color: "white",
                                    fontWeight: "bold",
                                    border: "1px solid #FF3100",
                                    width: 170,
                                    height: 35,
                                    whiteSpace: "normal",
                                    justifyContent: "center",
                                    borderRadius: "10px",

                                    "& .MuiChip-label": {
                                      fontSize: "0.9rem",
                                      paddingLeft: "4px",
                                      textAlign: "center",
                                    },
                                  }}
                                />{" "}
                                <span style={{ color: COLORS.danger }}>*</span>
                              </label>
                            </strong>

                            <div className="left-section">
                              {renderCategoriesBodyWork()}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "2%" }}>
                        {/* Campo Ocupação */}
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                          <label
                            style={{ fontWeight: "bold" }}
                            htmlFor="occupation"
                            className="form-label"
                          >
                            Ocupação{" "}
                            <span style={{ color: COLORS.danger }}>*</span>
                          </label>

                          <div className="col-md-6">
                            <select
                              disabled={view}
                              className="form-select"
                              onChange={(e) => setOccupation(e.target.value)}
                              value={occupation || ""}
                              style={{
                                borderRadius: "10px",
                              }}
                            >
                              <option value="">Selecione</option>
                              <option value="Fracionado">Fracionado</option>
                              <option value="Dedicado">Dedicado</option>
                            </select>
                          </div>
                        </div>

                        {/* Campo Livre de Carga e Descarga */}
                        <div className="col-md-6 d-flex justify-content-end align-items-center">
                          <div className="free-charge-wrapper">
                            <label
                              htmlFor="freeOfCharge"
                              className="free-charge-title"
                            >
                              Livre de Carga e Descarga{" "}
                              <span style={{ color: COLORS.danger }}>*</span>
                            </label>

                            <div className="free-charge-group">
                              <input
                                disabled={view}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "SIM"}
                                value="SIM"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeYes"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeYes"
                                className="free-charge-btn free-charge-yes"
                              >
                                SIM
                              </label>

                              <input
                                disabled={view}
                                type="radio"
                                onChange={(e) =>
                                  setFreeOfCharge(e.target.value)
                                }
                                checked={freeOfCharge === "NAO"}
                                value="NAO"
                                className="free-charge-radio"
                                name="freeOfCharge"
                                id="btnFreeNo"
                                autoComplete="off"
                              />
                              <label
                                htmlFor="btnFreeNo"
                                className="free-charge-btn free-charge-no"
                              >
                                NÃO
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>

                    {/* Precificação */}
                    {user?.permissoes?.freightPricing?.isView && (

                      <Card
                        sx={{ padding: 2, paddingLeft: 0 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <InventoryIcon style={{ color: COLORS.danger }} />{" "}
                          Precificação
                        </h4>
                        <div>
                          <ProductTable
                            product={product}
                            onChange={handleProductsChange}
                          />
                        </div>
                      </Card>

                    )}

                    {/* {user?.permissoes?.freightDriver?.isView && ( */}
                      <>
                        <FreightDriverNegotiationCard
                          view={view}
                          user={user}
                          canViewFreightDriver={canViewFreightDriverNegotiationUI}
                          canViewFreightDriverNegotiation={canViewFreightDriverNegotiation}
                          verifyPayment={verifyPayment}
                          valueDriverInitial={valueDriverInitial}
                          valueDriverFinal={valueDriverFinal}
                          valueNegotiated={valueNegotiated}
                          paymentCondition={paymentCondition}
                          driverChose={driverChose}
                          driversInFila={driversInFila}
                          uidDriver={uidDriver}
                          formatName={formatName}
                          onDriverInitialChange={handleChangeInitial}
                          onDriverFinalChange={handleChangeFinal}
                          onNegotiatedChange={handleChangeValueNegotiated}
                          onPaymentConditionChange={handleChangePaymentCondition}
                          onDriverSelect={handleDriver}
                        />
                      </>
                    {/* )} */}

                    {/* Grupos do embarcador (ordem drag-and-drop; groupOrder em shipper e frete) */}
                    {shipperGroups.length > 1 && (
                      <Card
                        sx={{ padding: 2, paddingLeft: 0 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3 "
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4 className="mb-3">
                          <GroupsIcon /> Grupos
                        </h4>

                        <div
                          className="row justify-content-between align-items-start gx-3"
                          style={{ marginLeft: "-15px" }}
                        >
                          <div className="col-12">
                            {shipperGroups.length === 0 ? (
                              <small className="text-muted">
                                Nenhum grupo disponível para este embarcador.
                              </small>
                            ) : (
                              <>
                                <DragDropContext onDragEnd={handleDragEndGroups}>
                                  <Droppable droppableId="groups">
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                      >
                                        {shipperGroups.map((group, index) => (
                                          <Draggable
                                            key={group.idGroup}
                                            draggableId={group.idGroup}
                                            index={index}
                                            isDragDisabled={view}
                                          >
                                            {(provided) => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="d-flex justify-content-between align-items-center mb-2"
                                                style={{
                                                  width: 300,
                                                  minHeight: 56,
                                                  padding: "12px 14px",
                                                  borderRadius: "12px",
                                                  background:
                                                    index === 0
                                                      ? "rgba(255,49,0,0.08)"
                                                      : "#FFFFFF",
                                                  border:
                                                    index === 0
                                                      ? "1px solid rgba(255,49,0,0.30)"
                                                      : "1px solid rgba(1,36,66,0.10)",
                                                  boxShadow:
                                                    "0px 3px 3px rgba(0,14,51,0.10), 0px 1px 2px rgba(0,14,51,0.08)",
                                                  cursor: view
                                                    ? "not-allowed"
                                                    : "grab",
                                                  transition: "all 0.2s ease",
                                                  ...provided.draggableProps
                                                    .style,
                                                }}
                                              >
                                                <div
                                                  className="d-flex align-items-center gap-2"
                                                  style={{ minWidth: 0 }}
                                                >
                                                  <span
                                                    style={{
                                                      minWidth: 28,
                                                      width: 28,
                                                      height: 28,
                                                      borderRadius: "999px",
                                                      background:
                                                        index === 0
                                                          ? "#FF3100"
                                                          : "#012442",
                                                      color: "#F9FAFB",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      fontWeight: 600,
                                                      fontSize: 12,
                                                      boxShadow:
                                                        "0px 3px 3px rgba(0,14,51,0.18), 0px 1px 2px rgba(0,14,51,0.12)",
                                                      flexShrink: 0,
                                                    }}
                                                  >
                                                    {index + 1}
                                                  </span>

                                                  <span
                                                    style={{
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      maxWidth: 260,
                                                      color: "#012442",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      lineHeight: 1.4,
                                                    }}
                                                    title={getGroupName(group)}
                                                  >
                                                    {getGroupName(group)}
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        ))}

                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </>
                            )}
                          </div>
                        </div>
                      </Card>
                    )}

                    {(canViewFreightSection || cargoStops.length > 0) && (
                      <Card
                        sx={{ padding: 2 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          <InventoryIcon style={{ color: COLORS.danger }} />{" "}
                          Produto
                        </h4>

                        {canViewFreightSection &&
                          !hasPerStopCargoFreightFields(formFields) && (
                          <div className="row justify-content-start align-items-center gx-3">
                            <div className="col-md-2 mb-4">
                              <label
                                htmlFor="weightCargo"
                                className="font-test"
                              >
                                Peso da Carga (Kg)
                              </label>
                              <IntlCurrencyInput
                                style={{
                                  borderRadius: "10px",
                                }}
                                disabled={view}
                                currency="BRL"
                                config={weightConfig}
                                placeholder="00.00"
                                onChange={handleChangeWeightCargo}
                                value={weightCargo && weightCargo}
                                className="form-control"
                                id="weightCargo"
                                maxLength={10}
                              />
                            </div>

                            <div className="col-md-2 mb-4">
                              <label htmlFor="valueNF" className="font-test">
                                Valor NF
                              </label>
                              <IntlCurrencyInput
                                disabled={view}
                                currency="BRL"
                                config={currencyConfig}
                                placeholder="00.00"
                                onChange={handleChangeValueNF}
                                value={valueNF && valueNF}
                                className="form-control"
                                id="valueNF"
                                maxLength={15}
                                style={{
                                  borderRadius: "10px",
                                }}
                              />
                            </div>

                            <div className="col-md-2 mb-4">
                              <ReadonlyField
                                id="valueFreightage"
                                label="Valor do Frete"
                                value={valueFreightage && valueFreightage}
                                config={currencyConfig}
                                currency="BRL"
                                className=""
                              />
                              {valueFreightage <
                                product.reduce(
                                  (acc, curr) =>
                                    acc + (curr.amount * curr.priceList || 0),
                                  0,
                                ) && (
                                  <small className="text-danger">
                                    O valor do frete esta menor que o valor total
                                    dos produtos.
                                  </small>
                                )}
                            </div>
                          </div>
                        )}

                        {cargoStops.length > 0 && (
                          <div>
                            {cargoStops.map(({ form, index }) => {
                              const stopLabel = `Parada ${form.stop_order || index + 1}`;

                              return (
                                <div
                                  className="row justify-content-start align-items-center gx-3"
                                  key={`product-${form.id || form.number_collect || index}`}
                                >
                                  <div className="col-md-2 mb-4">
                                    <label className="font-test">
                                      Ponto de Carga
                                    </label>
                                    <div>
                                      <Chip
                                        size="small"
                                        label={stopLabel}
                                        sx={{
                                          background: "#ffffff",
                                          border: `1px solid ${COLORS.line}`,
                                          color: COLORS.ink,
                                          fontWeight: 600,
                                          boxShadow: SOFT_SHADOW,
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {canViewFreightSection && (
                                    <>
                                      <div className="col-md-2 mb-4">
                                        <label
                                          htmlFor={`weight-cargo-stop-${index}`}
                                          className="font-test"
                                        >
                                          Peso da Carga (Kg){" "}
                                          <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <IntlCurrencyInput
                                          style={{ borderRadius: "10px" }}
                                          disabled={view}
                                          currency="BRL"
                                          config={weightConfig}
                                          placeholder="00.00"
                                          onChange={(event, value) => {
                                            event.preventDefault();
                                            handleCargoProductChange(
                                              index,
                                              "cargo_weight_kg",
                                              value,
                                            );
                                          }}
                                          value={
                                            form.cargo_weight_kg !== undefined &&
                                            form.cargo_weight_kg !== null &&
                                            form.cargo_weight_kg !== ""
                                              ? form.cargo_weight_kg
                                              : 0
                                          }
                                          className="form-control"
                                          id={`weight-cargo-stop-${index}`}
                                          maxLength={10}
                                        />
                                      </div>
                                      <div className="col-md-2 mb-4">
                                        <label
                                          htmlFor={`value-nf-stop-${index}`}
                                          className="font-test"
                                        >
                                          Valor NF{" "}
                                          <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <IntlCurrencyInput
                                          disabled={view}
                                          currency="BRL"
                                          config={currencyConfig}
                                          placeholder="00.00"
                                          onChange={(event, value) => {
                                            event.preventDefault();
                                            handleCargoProductChange(
                                              index,
                                              "cargo_value_nf",
                                              value,
                                            );
                                          }}
                                          value={
                                            form.cargo_value_nf !== undefined &&
                                            form.cargo_value_nf !== null &&
                                            form.cargo_value_nf !== ""
                                              ? form.cargo_value_nf
                                              : ""
                                          }
                                          className="form-control"
                                          id={`value-nf-stop-${index}`}
                                          maxLength={15}
                                          style={{ borderRadius: "10px" }}
                                        />
                                      </div>
                                    </>
                                  )}

                                  <div
                                    className={`mb-4 ${
                                      canViewFreightSection
                                        ? "col-md-2"
                                        : "col-md-3"
                                    }`}
                                  >
                                    <label
                                      htmlFor={`type-${index}`}
                                      className="font-test"
                                    >
                                      Tipo de Mercadoria{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      disabled={view}
                                      className="form-select"
                                      id={`type-${index}`}
                                      onChange={(e) =>
                                        handleCargoProductChange(
                                          index,
                                          "type",
                                          e.target.value || "",
                                        )
                                      }
                                      value={form.type || ""}
                                      aria-label=""
                                    >
                                      <option value="">Selecione</option>
                                      {MERCHANDISE_TYPE_OPTIONS.map(
                                        (option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </div>

                                  <div
                                    className={`mb-4 ${
                                      canViewFreightSection
                                        ? "col-md-4"
                                        : "col-md-5"
                                    }`}
                                  >
                                    <label
                                      htmlFor={`descricao-${index}`}
                                      className="font-test"
                                    >
                                      Descrição de Mercadoria{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="descricao"
                                      className="form-control"
                                      id={`descricao-${index}`}
                                      value={form.descricao || ""}
                                      onChange={(e) =>
                                        handleCargoProductChange(
                                          index,
                                          "descricao",
                                          e.target.value || "",
                                        )
                                      }
                                      placeholder="Descrição da mercadoria"
                                      style={{ borderRadius: "10px" }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                            {canViewFreightSection &&
                              cargoStops.length > 0 &&
                              hasPerStopCargoFreightFields(formFields) && (
                              <div className="row justify-content-start align-items-end gx-3 mt-1">
                                <ReadonlyField
                                  id="weightCargoTotal"
                                  label="Peso total (Kg)"
                                  value={sumCargoStopsNumber(
                                    formFields,
                                    "cargo_weight_kg",
                                  )}
                                  config={weightConfig}
                                  currency="BRL"
                                />
                                <ReadonlyField
                                  id="valueNFTotal"
                                  label="Valor NF total"
                                  value={sumCargoStopsNumber(
                                    formFields,
                                    "cargo_value_nf",
                                  )}
                                  config={currencyConfig}
                                />
                                <div className="col-md-2 mb-4">
                                  <ReadonlyField
                                    id="valueFreightage"
                                    label="Valor do Frete"
                                    value={valueFreightage && valueFreightage}
                                    config={currencyConfig}
                                    currency="BRL"
                                    className=""
                                  />
                                  {valueFreightage <
                                    product.reduce(
                                      (acc, curr) =>
                                        acc +
                                        (curr.amount * curr.priceList || 0),
                                      0,
                                    ) && (
                                    <small className="text-danger">
                                      O valor do frete esta menor que o valor total
                                      dos produtos.
                                    </small>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </Card>
                    )}

                    {/* FRETE */}
                    {user?.permissoes?.freightFreight?.isView && (

                      <Card
                        sx={{ padding: 2 }}
                        className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                        style={{
                          background: "#ffffff",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                          borderRadius: "16px",
                        }}
                      >
                        <h4
                          className="mb-3"
                          style={{
                            alignItems: "center",
                            color: COLORS.ink,
                            display: "flex",
                            fontWeight: 700,
                            gap: "8px",
                            margin: 0,
                          }}
                        >
                          {" "}
                          <FireTruckOutlinedIcon
                            style={{ color: COLORS.danger }}
                          />{" "}
                          Frete
                        </h4>

                        <div className="row align-items-center gx-3">
                          <div className="col-3">
                            <label htmlFor="seller" className="font-test">
                              Vendedor{" "}
                              <span style={{ color: COLORS.danger }}>*</span>
                            </label>

                            <Autocomplete
                              sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "10px",
                                },
                              }}
                              disabled={view}
                              id="seller-select"
                              size="small"
                              options={sellersList}
                              getOptionLabel={(option) =>
                                typeof option === "string"
                                  ? option
                                  : formatName(option.name)
                              }
                              value={
                                sellersList.find((s) => s.name === seller) ||
                                seller
                              }
                              onChange={(event, newValue) => {
                                setSeller(newValue ? newValue.name : "");
                              }}
                              // clearOnBlur
                              onInputChange={(event, newInputValue) => {
                                setSeller(newInputValue);
                              }}
                              noOptionsText="Nenhum vendedor encontrado"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label=""
                                  placeholder="Selecione o vendedor"
                                  id="seller"
                                />
                              )}
                              isOptionEqualToValue={(option, value) =>
                                option.name === value.name
                              }
                              forcePopupIcon={true}
                              popupIcon={<KeyboardArrowDownIcon />}
                            />
                          </div>

                          <div className="col-3">
                            <label htmlFor="operational" className="font-test">
                              Operacional
                            </label>
                            <input
                              style={{
                                borderRadius: "10px",
                              }}
                              disabled={true}
                              type="text"
                              onChange={(e) => setOperational(e.target.value)}
                              value={operational && operational}
                              className="form-control"
                              id="operational"
                              placeholder=""
                            />
                          </div>

                          <div className="col-2">
                            <label
                              htmlFor="phoneRespContractFreigtage"
                              className="font-test"
                            >
                              Resp. contratação frete
                            </label>
                            <InputMask
                              style={{
                                borderRadius: "10px",
                              }}
                              disabled={view}
                              mask="(99) 99999-9999"
                              className="form-control"
                              onChange={(e) =>
                                setPhoneRespContractFreigtage(e.target.value)
                              }
                              value={
                                phoneRespContractFreigtage &&
                                phoneRespContractFreigtage
                              }
                              placeholder="(99) 99999-9999"
                            />
                          </div>
                        </div>

                      </Card>

                    )}

                    {/* Dados da entrega */}
                    <Card
                      sx={{ padding: 2 }}
                      className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                      style={{
                        background: "#ffffff",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                        borderRadius: "16px",
                      }}
                    >
                      <div className="form-signin mx-auto">
                        <div className="col-12">
                          <h4
                            className="mb-3"
                            style={{
                              alignItems: "center",
                              color: COLORS.ink,
                              display: "flex",
                              fontWeight: 700,
                              gap: "8px",
                              margin: 0,
                            }}
                          >
                            {" "}
                            <StorageOutlinedIcon
                              style={{ color: COLORS.danger }}
                            />{" "}
                            Dados da entrega
                          </h4>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <label htmlFor="observation" className="font-test">
                              Observações Motorista
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) => setObservation(e.target.value)}
                              value={observation || ""}
                              id="observation"
                              rows="3"
                              maxLength={300}
                              style={{
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {observation?.length || 0}/300
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-signin mx-auto">
                        <div className="row">
                          <div className="col-12">
                            <label
                              htmlFor="internalObservations"
                              className="font-test"
                            >
                              Observações internas
                            </label>
                            <textarea
                              disabled={view}
                              className="form-control"
                              onChange={(e) =>
                                setInternalObservations(e.target.value)
                              }
                              value={
                                internalObservations && internalObservations
                              }
                              id="internalObservations"
                              rows="3"
                              maxLength={300}
                              style={{
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              className="text-end text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {internalObservations?.length || 0}/300
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col-4"></div>
                      <div className="col-4"></div>
                      <div
                        className="col-4"
                        style={{
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          <Link to={"/freightlist"}>
                            <BackButton />
                          </Link>
                        </div>

                        {id &&
                          (code === "04" || code === "05" || code === "06") ? (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1 }}
                          >
                            {carregando ? (
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="visually-hidden ">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <button
                                disabled={view}
                                type="submit"
                                onClick={(e) => update(true, false)}
                                className="w-100 btn btn-primary btn-cadastrar"
                              >
                                {"Finalizar"}
                              </button>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1 }}
                        >
                          {carregando ? (
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="visually-hidden ">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <button
                              disabled={view || carregando}
                              type="submit"
                              onClick={(e) => handleSave()}
                              className="w-100 btn btn-primary btn-cadastrar"
                            >
                              {"Salvar"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <ModernAlertDialog
                      open={open}
                      handleClose={handleClose}
                      title={title}
                      msg={msg}
                    />
                  </div>

                  <div>
                    <CancelFreightDialog
                      open={openCancelDialog}
                      loading={carregando === 1}
                      onClose={() => setOpenCancelDialog(false)}
                      onConfirm={handleCancelFreight}
                    />
                  </div>

                  <div>
                    <CancelFreightDialog
                      open={openReactivateDialog}
                      loading={carregando === 1}
                      onClose={() => setOpenReactivateDialog(false)}
                      onConfirm={handleReactivateFreight}
                      title="Reativar frete"
                      confirmOnly
                    />
                  </div>

                  <div>
                    <Dialog
                      open={openDialog}
                      keepMounted
                      onClose={handleCloseDialog}
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogTitle>{title}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                          {msg}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseDialog}>Cancelar</Button>
                        <Button onClick={handleClickDialog}>OK</Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
              </Box>
            }
          />
        ) : (
          <Navigate to="/login" />
        )}

        <FreightEditedSuccessModal
          open={openSuccessModal}
          handleClose={() => handleModalResult(true)}
          onResult={handleModalResult}
          dataMsg={openFreightEditedSuccessModal}
        />
      </>
    </div>
  );
}

export default FreightCopy;
